export var ActionType;
(function (ActionType) {
    ActionType["NONE"] = "NONE";
    ActionType["OAUTH2"] = "OAUTH2";
    ActionType["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
    ActionType["EDITOR"] = "EDITOR";
    ActionType["DASHBOARD"] = "DASHBOARD";
    ActionType["CREATE_SITE"] = "CREATE_SITE";
})(ActionType || (ActionType = {}));
export var VersionStatus;
(function (VersionStatus) {
    /** default, internal use status. do not use */
    VersionStatus["NONE_STATUS"] = "NONE_STATUS";
    /** a version which was created in the dev center and has not started the approval process yet */
    VersionStatus["DRAFT"] = "DRAFT";
    /** the version was submitted for review by the developer */
    VersionStatus["SUBMITTED"] = "SUBMITTED";
    /** the version is being reviewed by the app market team in cactus */
    VersionStatus["IN_REVIEW"] = "IN_REVIEW";
    /** our team approved the version */
    VersionStatus["APPROVED"] = "APPROVED";
    /** this version is published - only one version can be published at any given time; if this app was already published, the previously published version's status is now ARCHIVED */
    VersionStatus["PUBLISHED"] = "PUBLISHED";
    /** our team did not accept this version of the app */
    VersionStatus["DECLINED"] = "DECLINED";
    /** the status for versions that are no longer relevant */
    VersionStatus["ARCHIVED"] = "ARCHIVED";
    /** status for versions with no significant changes, e.g. for test app. for questions contact our team */
    VersionStatus["HIDDEN"] = "HIDDEN";
    /** mark apps as RELEASED, without adding to the apps cache, and allow users to install */
    VersionStatus["RELEASED"] = "RELEASED";
})(VersionStatus || (VersionStatus = {}));
/** Component type */
export var ComponentType;
(function (ComponentType) {
    ComponentType["NONE"] = "NONE";
    ComponentType["STUDIO"] = "STUDIO";
    ComponentType["PLATFORM"] = "PLATFORM";
    ComponentType["WORKER"] = "WORKER";
    ComponentType["DASHBOARD"] = "DASHBOARD";
    ComponentType["WIDGET"] = "WIDGET";
    ComponentType["PAGE"] = "PAGE";
    ComponentType["DASHBOARD_PLATFORM"] = "DASHBOARD_PLATFORM";
    ComponentType["STUDIO_WIDGET"] = "STUDIO_WIDGET";
    ComponentType["EMBEDDED_SCRIPT"] = "EMBEDDED_SCRIPT";
    ComponentType["EXTENSION"] = "EXTENSION";
    ComponentType["SNIPPET_SOLUTION"] = "SNIPPET_SOLUTION";
    ComponentType["DATA_COMPONENT"] = "DATA_COMPONENT";
    ComponentType["WEB"] = "WEB";
    ComponentType["DC_CONFIG"] = "DC_CONFIG";
    ComponentType["WIDGET_OUT_OF_IFRAME"] = "WIDGET_OUT_OF_IFRAME";
    ComponentType["PAGE_OUT_OF_IFRAME"] = "PAGE_OUT_OF_IFRAME";
    ComponentType["STATIC_FILE"] = "STATIC_FILE";
    ComponentType["APP_CONFIG"] = "APP_CONFIG";
    ComponentType["MULTIPLE_DASHBOARDS"] = "MULTIPLE_DASHBOARDS";
    ComponentType["PAYMENTS_GATEWAY"] = "PAYMENTS_GATEWAY";
    ComponentType["CODE_PACKAGE"] = "CODE_PACKAGE";
    ComponentType["AUTOMATION_TRIGGER"] = "AUTOMATION_TRIGGER";
    ComponentType["INVOICES_ACTIONS"] = "INVOICES_ACTIONS";
    ComponentType["DASHBOARD_APPLICATION"] = "DASHBOARD_APPLICATION";
    ComponentType["CONTACT_LABELS"] = "CONTACT_LABELS";
    ComponentType["WIDGET_PLUGIN"] = "WIDGET_PLUGIN";
    ComponentType["CROSS_SELL"] = "CROSS_SELL";
    ComponentType["LOCAL_DELIVERY"] = "LOCAL_DELIVERY";
    ComponentType["PAYMENT_PROVIDER"] = "PAYMENT_PROVIDER";
    ComponentType["ECOM_MEMBERSHIPS"] = "ECOM_MEMBERSHIPS";
    ComponentType["ECOM_LINE_ITEMS_ENRICHER"] = "ECOM_LINE_ITEMS_ENRICHER";
    ComponentType["ECOM_SHIPPING_RATES"] = "ECOM_SHIPPING_RATES";
    ComponentType["SHIPPING_LABEL_CARRIER"] = "SHIPPING_LABEL_CARRIER";
    ComponentType["RESTAURANTS_POS"] = "RESTAURANTS_POS";
    ComponentType["FICTIONAL_SHIPPING_PROVIDER"] = "FICTIONAL_SHIPPING_PROVIDER";
    ComponentType["ALERT_ENRICHER"] = "ALERT_ENRICHER";
    ComponentType["DATA_EXTENSIONS"] = "DATA_EXTENSIONS";
    ComponentType["GENERIC_HOOKS"] = "GENERIC_HOOKS";
    ComponentType["AUTOMATIONS_ACTION_PROVIDER"] = "AUTOMATIONS_ACTION_PROVIDER";
    ComponentType["ECOM_CATALOG"] = "ECOM_CATALOG";
    ComponentType["BACK_OFFICE_EXTENSION_CONTAINER"] = "BACK_OFFICE_EXTENSION_CONTAINER";
    ComponentType["BACK_OFFICE_EXTENSION"] = "BACK_OFFICE_EXTENSION";
    ComponentType["AUTOMATIONS_TRIGGER_PROVIDER"] = "AUTOMATIONS_TRIGGER_PROVIDER";
    ComponentType["IDENTITY_PRE_REGISTRATION"] = "IDENTITY_PRE_REGISTRATION";
    ComponentType["PREMIUM_PRODUCTS_PATHS"] = "PREMIUM_PRODUCTS_PATHS";
    ComponentType["ECOM_CUSTOM_SCOPE"] = "ECOM_CUSTOM_SCOPE";
    ComponentType["GIFT_CARDS_PROVIDER"] = "GIFT_CARDS_PROVIDER";
    ComponentType["DEALER_EXTERNAL_FILTER_PROVIDER"] = "DEALER_EXTERNAL_FILTER_PROVIDER";
    ComponentType["ECOM_DROPSHIPPING_PROVIDER"] = "ECOM_DROPSHIPPING_PROVIDER";
    ComponentType["INVOICES_PROVIDER"] = "INVOICES_PROVIDER";
    ComponentType["SEO_KEYWORDS_SUGGESTIONS"] = "SEO_KEYWORDS_SUGGESTIONS";
    ComponentType["ECOM_DISCOUNTS_TRIGGER"] = "ECOM_DISCOUNTS_TRIGGER";
    ComponentType["MULTILINGUAL_CONTENT_PROVIDER"] = "MULTILINGUAL_CONTENT_PROVIDER";
    ComponentType["APPLICATION_AUTOMATION"] = "APPLICATION_AUTOMATION";
    ComponentType["BACK_OFFICE_SIDEBAR_CATEGORY"] = "BACK_OFFICE_SIDEBAR_CATEGORY";
    ComponentType["BACK_OFFICE_PAGE"] = "BACK_OFFICE_PAGE";
    ComponentType["ECOM_ADDITIONAL_FEES"] = "ECOM_ADDITIONAL_FEES";
    ComponentType["PING_USER_NOTIFICATION"] = "PING_USER_NOTIFICATION";
    ComponentType["ECOM_RECOMMENDATIONS_PROVIDER"] = "ECOM_RECOMMENDATIONS_PROVIDER";
    ComponentType["BOOKINGS_PRICING_PROVIDER"] = "BOOKINGS_PRICING_PROVIDER";
    ComponentType["IDENTITY_AUTHENTICATOR"] = "IDENTITY_AUTHENTICATOR";
    ComponentType["IDENTITY_IDP_CONNECTOR"] = "IDENTITY_IDP_CONNECTOR";
    ComponentType["ITEMS_SELECTION_PROVIDER"] = "ITEMS_SELECTION_PROVIDER";
    ComponentType["PORTFOLIO_SYNCED_PROJECTS_PROVIDER"] = "PORTFOLIO_SYNCED_PROJECTS_PROVIDER";
    ComponentType["COMMUNICATION_CHANNEL"] = "COMMUNICATION_CHANNEL";
    ComponentType["IDENTITY_POST_LOGIN"] = "IDENTITY_POST_LOGIN";
    ComponentType["BACK_OFFICE_WIDGET"] = "BACK_OFFICE_WIDGET";
    ComponentType["SOCIAL_MARKETING_DESIGN"] = "SOCIAL_MARKETING_DESIGN";
    ComponentType["FORMS_SUBMISSIONS_PROVIDER"] = "FORMS_SUBMISSIONS_PROVIDER";
    ComponentType["WIX_OFFERING"] = "WIX_OFFERING";
    ComponentType["DEV_CENTER_TESTING_COMPONENT"] = "DEV_CENTER_TESTING_COMPONENT";
    ComponentType["COMPONENTS_VALIDATOR_PROVIDER"] = "COMPONENTS_VALIDATOR_PROVIDER";
    ComponentType["COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER"] = "COMPONENTS_TRANSLATIONS_ADDITIONAL_FIELDS_PROVIDER";
    ComponentType["FORMS_SCHEMA_PROVIDER"] = "FORMS_SCHEMA_PROVIDER";
    ComponentType["BOOKINGS_EXTERNAL_CALENDAR_PROVIDER"] = "BOOKINGS_EXTERNAL_CALENDAR_PROVIDER";
    ComponentType["ECOM_DEFAULT_TAXATION_CATEGORY"] = "ECOM_DEFAULT_TAXATION_CATEGORY";
    ComponentType["VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER"] = "VIEWER_DYNAMIC_SITE_STRUCTURE_PROVIDER";
    ComponentType["PING_UOU_NOTIFICATION"] = "PING_UOU_NOTIFICATION";
    ComponentType["HEADLESS_OAUTH"] = "HEADLESS_OAUTH";
    ComponentType["ECOM_TAX_CALCULATOR_SPI"] = "ECOM_TAX_CALCULATOR_SPI";
    ComponentType["COMMENTS_MODERATION_PROVIDER"] = "COMMENTS_MODERATION_PROVIDER";
    ComponentType["GRID_APP_FILES_TRANSFORMER"] = "GRID_APP_FILES_TRANSFORMER";
    ComponentType["BENEFIT_PROGRAMS_POLICY_PROVIDER"] = "BENEFIT_PROGRAMS_POLICY_PROVIDER";
    ComponentType["PREMIUM_CUSTOM_CHARGES"] = "PREMIUM_CUSTOM_CHARGES";
    ComponentType["ECOM_VALIDATIONS"] = "ECOM_VALIDATIONS";
    ComponentType["COMPONENT_REFERENCE_DATA_PROVIDER"] = "COMPONENT_REFERENCE_DATA_PROVIDER";
    ComponentType["WIX_REVIEWS_PRODUCT_CATALOG"] = "WIX_REVIEWS_PRODUCT_CATALOG";
    ComponentType["SOCIAL_MARKETING_DESIGNS_PROVIDER"] = "SOCIAL_MARKETING_DESIGNS_PROVIDER";
    ComponentType["GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER"] = "GOOGLE_BUSINESS_PROFILE_FEATURE_PROVIDER";
    ComponentType["COMMENTS_FILTER_PROVIDER"] = "COMMENTS_FILTER_PROVIDER";
    ComponentType["BILLING_TAX_ID_VALIDATOR"] = "BILLING_TAX_ID_VALIDATOR";
    ComponentType["PING_SETTINGS_GROUP"] = "PING_SETTINGS_GROUP";
    ComponentType["FORMS_SPAM_SUBMISSIONS_PROVIDER"] = "FORMS_SPAM_SUBMISSIONS_PROVIDER";
    ComponentType["EDITOR_ADDON"] = "EDITOR_ADDON";
    ComponentType["EXTERNAL_DATABASE_PROVIDER"] = "EXTERNAL_DATABASE_PROVIDER";
    ComponentType["ECOM_PAYMENT_SETTINGS"] = "ECOM_PAYMENT_SETTINGS";
    ComponentType["NOTIFICATION_TOPIC"] = "NOTIFICATION_TOPIC";
    ComponentType["NOTIFICATION_PREFERENCES_FILTER_PROVIDER"] = "NOTIFICATION_PREFERENCES_FILTER_PROVIDER";
    ComponentType["BOOKINGS_RESOURCE_TYPES_PROVIDER"] = "BOOKINGS_RESOURCE_TYPES_PROVIDER";
    ComponentType["PRICING_PLANS_FORM_CONFIGURATION"] = "PRICING_PLANS_FORM_CONFIGURATION";
    ComponentType["USER_NOTIFICATION"] = "USER_NOTIFICATION";
    ComponentType["CONTACT_NOTIFICATION"] = "CONTACT_NOTIFICATION";
    ComponentType["UNIFIED_PAGE"] = "UNIFIED_PAGE";
    ComponentType["AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER"] = "AVAILABILITY_TIME_SLOTS_CONFIGURATION_PROVIDER";
    ComponentType["PROPOSAL_EDITOR_PROVIDER"] = "PROPOSAL_EDITOR_PROVIDER";
    ComponentType["CUSTOM_TABLE_RESERVATIONS_PROVIDER"] = "CUSTOM_TABLE_RESERVATIONS_PROVIDER";
    ComponentType["COMMENTS_CONTEXT_PROVIDER"] = "COMMENTS_CONTEXT_PROVIDER";
    ComponentType["FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER"] = "FORMS_SPAM_SUBMISSION_REPORTS_PROVIDER";
    ComponentType["AUTOMATIONS_VELO_ACTION_PROVIDER"] = "AUTOMATIONS_VELO_ACTION_PROVIDER";
    ComponentType["CALENDAR_EVENT_TYPE_PROVIDER"] = "CALENDAR_EVENT_TYPE_PROVIDER";
    /** Reserved - previously was `SERVICE_AVAILABILITY_POLICY_PROVIDER` */
    ComponentType["RESERVED"] = "RESERVED";
    ComponentType["SMS_ACTION_MESSAGE"] = "SMS_ACTION_MESSAGE";
    ComponentType["BOOKING_POLICY_PROVIDER"] = "BOOKING_POLICY_PROVIDER";
    ComponentType["MULTI_SERVICE_BOOKING_POLICY_PROVIDER"] = "MULTI_SERVICE_BOOKING_POLICY_PROVIDER";
    ComponentType["AI_ASSISTANT"] = "AI_ASSISTANT";
    ComponentType["FORMS_SUBMISSIONS_EXTENSION_PROVIDER"] = "FORMS_SUBMISSIONS_EXTENSION_PROVIDER";
    ComponentType["MULTILINGUAL_TRANSLATION_SCHEMA"] = "MULTILINGUAL_TRANSLATION_SCHEMA";
    ComponentType["TAX_CALCULATION_PROVIDER"] = "TAX_CALCULATION_PROVIDER";
    ComponentType["TAX_GROUPS_PROVIDER"] = "TAX_GROUPS_PROVIDER";
    ComponentType["BACK_OFFICE_MODAL"] = "BACK_OFFICE_MODAL";
    ComponentType["DEPLOYMENT_PIPELINE_PROVIDER"] = "DEPLOYMENT_PIPELINE_PROVIDER";
    ComponentType["CUSTOM_ELEMENT_WIDGET"] = "CUSTOM_ELEMENT_WIDGET";
    ComponentType["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
    ComponentType["BACK_OFFICE_EXTENSION_MENU_ITEM"] = "BACK_OFFICE_EXTENSION_MENU_ITEM";
    ComponentType["FORM_TEMPLATE"] = "FORM_TEMPLATE";
    ComponentType["NOTIFICATION_CONTENT"] = "NOTIFICATION_CONTENT";
    ComponentType["BROADCAST_LIST"] = "BROADCAST_LIST";
    ComponentType["PARTNERS_PAYOUTS"] = "PARTNERS_PAYOUTS";
    ComponentType["WIX_REVIEWS_ENTITY_CATALOG"] = "WIX_REVIEWS_ENTITY_CATALOG";
    ComponentType["VELO_PUBLISH_PIPELINE_TASK_PROVIDER"] = "VELO_PUBLISH_PIPELINE_TASK_PROVIDER";
    ComponentType["FUNCTIONS_SHOP_PRICE_PROVIDER"] = "FUNCTIONS_SHOP_PRICE_PROVIDER";
    ComponentType["FUNCTION"] = "FUNCTION";
    ComponentType["ECOM_CHECKOUT_CONTENT"] = "ECOM_CHECKOUT_CONTENT";
    ComponentType["COMMUNICATION_CHANNEL_PROVIDER"] = "COMMUNICATION_CHANNEL_PROVIDER";
    ComponentType["WEBHOOK"] = "WEBHOOK";
    ComponentType["TOPOLOGY"] = "TOPOLOGY";
    ComponentType["LOYALTY_CUSTOM_REWARDS"] = "LOYALTY_CUSTOM_REWARDS";
    ComponentType["FUNCTION_RECIPE"] = "FUNCTION_RECIPE";
    ComponentType["BACK_OFFICE_EXTERNAL_URL"] = "BACK_OFFICE_EXTERNAL_URL";
    ComponentType["IDENTITY_FACTOR"] = "IDENTITY_FACTOR";
    ComponentType["ECOM_DISCOUNTS"] = "ECOM_DISCOUNTS";
    ComponentType["VELO_CUSTOM_CSS"] = "VELO_CUSTOM_CSS";
    ComponentType["DEALER_ADAPTIVE_COMPONENT_PROVIDER"] = "DEALER_ADAPTIVE_COMPONENT_PROVIDER";
    ComponentType["AI_ASSISTANT_ACTION"] = "AI_ASSISTANT_ACTION";
    ComponentType["ECOM_INVENTORY"] = "ECOM_INVENTORY";
    ComponentType["MONITORING"] = "MONITORING";
    ComponentType["PAPI_PROVIDER"] = "PAPI_PROVIDER";
    ComponentType["UNIFIED_LIGHTBOX"] = "UNIFIED_LIGHTBOX";
    ComponentType["FORMS_EXTENSION_PROVIDER"] = "FORMS_EXTENSION_PROVIDER";
    ComponentType["MULTILINGUAL_TRANSLATION_SCHEMA_GROUP"] = "MULTILINGUAL_TRANSLATION_SCHEMA_GROUP";
    ComponentType["PANEL"] = "PANEL";
    ComponentType["PREMIUM_PURCHASE_VALIDATIONS"] = "PREMIUM_PURCHASE_VALIDATIONS";
    ComponentType["BROWSER_STORAGE"] = "BROWSER_STORAGE";
    ComponentType["SDK_DEFINITION"] = "SDK_DEFINITION";
    ComponentType["SITE_WIDGET_SLOT"] = "SITE_WIDGET_SLOT";
    ComponentType["CALENDAR_EVENT_VALIDATION_PROVIDER"] = "CALENDAR_EVENT_VALIDATION_PROVIDER";
    ComponentType["CLIENT_SIDE_SERVICE"] = "CLIENT_SIDE_SERVICE";
    ComponentType["BILLING_SETTINGS"] = "BILLING_SETTINGS";
    ComponentType["PATTERNS_WIZARD"] = "PATTERNS_WIZARD";
    ComponentType["APPLICATION_PROFILE"] = "APPLICATION_PROFILE";
    ComponentType["TEXT_TO_SPEECH_ACTION_MESSAGE"] = "TEXT_TO_SPEECH_ACTION_MESSAGE";
    ComponentType["AUDIENCE_PROVIDER"] = "AUDIENCE_PROVIDER";
    ComponentType["PRICING_PLANS_PRICE"] = "PRICING_PLANS_PRICE";
    ComponentType["PRICING_PLAN_START_DATE_LIMITS"] = "PRICING_PLAN_START_DATE_LIMITS";
    ComponentType["PRICING_PLAN_START_DATE_RULES"] = "PRICING_PLAN_START_DATE_RULES";
    ComponentType["EVENTS_TICKET_RESERVATIONS"] = "EVENTS_TICKET_RESERVATIONS";
    ComponentType["PAYMENTS_DISPUTE_SERVICE_PLUGIN"] = "PAYMENTS_DISPUTE_SERVICE_PLUGIN";
    ComponentType["PRICING_PLANS_FEES"] = "PRICING_PLANS_FEES";
    ComponentType["EDITOR_REACT_COMPONENT"] = "EDITOR_REACT_COMPONENT";
    ComponentType["SUPPLIERS_HUB_MARKETPLACE"] = "SUPPLIERS_HUB_MARKETPLACE";
    ComponentType["FORM_SCHEMA_DYNAMIC_VALUES"] = "FORM_SCHEMA_DYNAMIC_VALUES";
    ComponentType["BLOG_PAYWALL_PROVIDER"] = "BLOG_PAYWALL_PROVIDER";
    ComponentType["LOYALTY_CUSTOM_REWARDS_V2"] = "LOYALTY_CUSTOM_REWARDS_V2";
    ComponentType["STORES_PRODUCT_RESTRICTIONS"] = "STORES_PRODUCT_RESTRICTIONS";
    ComponentType["FORM_SUBMISSION_MODERATION"] = "FORM_SUBMISSION_MODERATION";
    ComponentType["EVENTS_EVENT_BADGES"] = "EVENTS_EVENT_BADGES";
    ComponentType["BILLING_OPERATION"] = "BILLING_OPERATION";
    ComponentType["BACK_OFFICE_CUSTOMIZATION"] = "BACK_OFFICE_CUSTOMIZATION";
    ComponentType["COMPONENT_ENRICHER_PROVIDER"] = "COMPONENT_ENRICHER_PROVIDER";
    ComponentType["BACK_OFFICE_RESTRICTED_CUSTOMIZATION"] = "BACK_OFFICE_RESTRICTED_CUSTOMIZATION";
    ComponentType["EDITOR_APP_PREVIEWS_POC"] = "EDITOR_APP_PREVIEWS_POC";
    ComponentType["LEGENDS_PERSONA_CONFIGURATION"] = "LEGENDS_PERSONA_CONFIGURATION";
    ComponentType["WIX_HOSTING_APP_DEPLOYMENT_PROVIDER"] = "WIX_HOSTING_APP_DEPLOYMENT_PROVIDER";
    ComponentType["BACKEND_WORKER"] = "BACKEND_WORKER";
    ComponentType["EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER"] = "EVENT_TIME_SLOTS_CONFIGURATION_PROVIDER";
    ComponentType["WIX_HOSTING_APP_ENVIRONMENT_PROVIDER"] = "WIX_HOSTING_APP_ENVIRONMENT_PROVIDER";
    ComponentType["SDK_EXPORTS"] = "SDK_EXPORTS";
    ComponentType["VIEWER_SERVICE"] = "VIEWER_SERVICE";
    ComponentType["WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN"] = "WIX_PAYMENTS_PROVIDER_ACCOUNT_SERVICE_PLUGIN";
    ComponentType["CONTACTS_SEGMENTS_V2_FILTER_PROVIDER"] = "CONTACTS_SEGMENTS_V2_FILTER_PROVIDER";
    ComponentType["ANALYTICS_PRODUCT_CATALOG"] = "ANALYTICS_PRODUCT_CATALOG";
    ComponentType["SITE_MIGRATION"] = "SITE_MIGRATION";
    ComponentType["RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN"] = "RESTAURANTS_POS_PROVIDER_SETTINGS_SERVICE_PLUGIN";
})(ComponentType || (ComponentType = {}));
/** Vertical widget position in the browser window */
export var WidgetVertical;
(function (WidgetVertical) {
    WidgetVertical["NONE_VERTICAL"] = "NONE_VERTICAL";
    WidgetVertical["TOP"] = "TOP";
    WidgetVertical["CENTER_VERTICAL"] = "CENTER_VERTICAL";
    WidgetVertical["BOTTOM"] = "BOTTOM";
})(WidgetVertical || (WidgetVertical = {}));
/** Horizontal widget position in the browser window */
export var WidgetHorizontal;
(function (WidgetHorizontal) {
    WidgetHorizontal["NONE_HORIZONTAL"] = "NONE_HORIZONTAL";
    WidgetHorizontal["LEFT"] = "LEFT";
    WidgetHorizontal["CENTER_HORIZONTAL"] = "CENTER_HORIZONTAL";
    WidgetHorizontal["RIGHT"] = "RIGHT";
})(WidgetHorizontal || (WidgetHorizontal = {}));
/** Widget will automatically be stretched to this width after installing it */
export var WidgetWidthType;
(function (WidgetWidthType) {
    WidgetWidthType["NONE_TYPE"] = "NONE_TYPE";
    /** A custom width for the widget */
    WidgetWidthType["CUSTOM"] = "CUSTOM";
    /** Full width of the browser window */
    WidgetWidthType["FULL"] = "FULL";
})(WidgetWidthType || (WidgetWidthType = {}));
export var Region;
(function (Region) {
    Region["no_region"] = "no_region";
    Region["header"] = "header";
    Region["pageContainer"] = "pageContainer";
    Region["footer"] = "footer";
})(Region || (Region = {}));
export var UnitType;
(function (UnitType) {
    UnitType["NO_UNIT"] = "NO_UNIT";
    UnitType["AUTO"] = "AUTO";
    UnitType["PX"] = "PX";
    UnitType["VH"] = "VH";
    UnitType["VW"] = "VW";
    UnitType["PERCENTAGE"] = "PERCENTAGE";
})(UnitType || (UnitType = {}));
export var HorizontalDocking;
(function (HorizontalDocking) {
    HorizontalDocking["NO_HDOCKING"] = "NO_HDOCKING";
    HorizontalDocking["LEFT_DOCKING"] = "LEFT_DOCKING";
    HorizontalDocking["HCENTER"] = "HCENTER";
    HorizontalDocking["RIGHT_DOCKING"] = "RIGHT_DOCKING";
})(HorizontalDocking || (HorizontalDocking = {}));
export var VerticalDocking;
(function (VerticalDocking) {
    VerticalDocking["NO_VDOCKING"] = "NO_VDOCKING";
    VerticalDocking["TOP_DOCKING"] = "TOP_DOCKING";
    VerticalDocking["VCENTER"] = "VCENTER";
    VerticalDocking["BOTTOM_DOCKING"] = "BOTTOM_DOCKING";
})(VerticalDocking || (VerticalDocking = {}));
/** SSR caching configuration for site members */
export var SiteMembersSsrCaching;
(function (SiteMembersSsrCaching) {
    SiteMembersSsrCaching["UNKNOWN_SITE_MEMBERS_SSR_CACHING"] = "UNKNOWN_SITE_MEMBERS_SSR_CACHING";
    /** SSR caching is allowed when site members are logged in */
    SiteMembersSsrCaching["CACHING_ALLOWED"] = "CACHING_ALLOWED";
    /** SSR caching is not allowed when site members are logged in */
    SiteMembersSsrCaching["CACHING_NOT_ALLOWED"] = "CACHING_NOT_ALLOWED";
})(SiteMembersSsrCaching || (SiteMembersSsrCaching = {}));
export var ReplacementType;
(function (ReplacementType) {
    ReplacementType["UNKNOWN_REPLACEMENT"] = "UNKNOWN_REPLACEMENT";
    ReplacementType["REPLACING"] = "REPLACING";
    ReplacementType["REPLACEABLE"] = "REPLACEABLE";
})(ReplacementType || (ReplacementType = {}));
/** The types of public APIs exposed by the Plugin */
export var PluginInterface;
(function (PluginInterface) {
    /** No public APIs exposed */
    PluginInterface["NONE_INTERFACE"] = "NONE_INTERFACE";
    /** The slot requires the REVIEWS interface to be implemented by the plugin. The plugin specifies the implementation of the REVIEWS interface */
    PluginInterface["REVIEWS"] = "REVIEWS";
    /** The slot requires the RATINGS_SUMMARY interface to be implemented by the plugin. The plugin specifies the implementation of the RATINGS_SUMMARY interface */
    PluginInterface["RATINGS_SUMMARY"] = "RATINGS_SUMMARY";
    /** The slot requires the RATINGS_SUMMARY_OOI_LIST interface to be implemented by the plugin. The plugin specifies the implementation of the RATINGS_SUMMARY_OOI_LIST interface */
    PluginInterface["RATINGS_SUMMARY_OOI_LIST"] = "RATINGS_SUMMARY_OOI_LIST";
    /** The slot requires the BOOKINGS_SERVICE interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_SERVICE interface */
    PluginInterface["BOOKINGS_SERVICE"] = "BOOKINGS_SERVICE";
    /** The slot requires the BOOKINGS_FORM interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_FORM interface */
    PluginInterface["BOOKINGS_FORM"] = "BOOKINGS_FORM";
    /** The slot requires the BASE interface to be implemented by the plugin. The plugin specifies the implementation of the BASE interface */
    PluginInterface["BASE"] = "BASE";
    /** The slot requires the EVENT interface to be implemented by the plugin. The plugin specifies the implementation of the EVENT interface */
    PluginInterface["EVENT"] = "EVENT";
    /** The slot requires the PRODUCT interface to be implemented by the plugin. The plugin specifies the implementation of the PRODUCT interface */
    PluginInterface["PRODUCT"] = "PRODUCT";
    /** The slot requires the CHECKOUT interface to be implemented by the plugin. The plugin specifies the implementation of the CHECKOUT interface */
    PluginInterface["CHECKOUT"] = "CHECKOUT";
    /** The slot requires the CATEGORY interface to be implemented by the plugin. The plugin specifies the implementation of the CATEGORY interface */
    PluginInterface["CATEGORY"] = "CATEGORY";
    /** The slot requires the BOOKINGS_CALENDAR interface to be implemented by the plugin. The plugin specifies the implementation of the BOOKINGS_CALENDAR interface */
    PluginInterface["BOOKINGS_CALENDAR"] = "BOOKINGS_CALENDAR";
    /** The slot requires the CART interface to be implemented by the plugin. The plugin specifies the implementation of the CART interface */
    PluginInterface["CART"] = "CART";
})(PluginInterface || (PluginInterface = {}));
export var ExtensionExposureExposure;
(function (ExtensionExposureExposure) {
    /** Unexposed. to be used by dev team only */
    ExtensionExposureExposure["PRIVATE"] = "PRIVATE";
    /** Exposed internally */
    ExtensionExposureExposure["INTERNAL"] = "INTERNAL";
    /** Exposed to the world */
    ExtensionExposureExposure["PUBLIC"] = "PUBLIC";
})(ExtensionExposureExposure || (ExtensionExposureExposure = {}));
export var Maturity;
(function (Maturity) {
    /** Immature. subject to breaking changes */
    Maturity["ALPHA"] = "ALPHA";
    /** Ready for integration. 2 weeks notice before breaking changes are applied */
    Maturity["BETA"] = "BETA";
    /** Matured. breaking changes are not acceptable. 3 month notice before sunset */
    Maturity["GA"] = "GA";
    /** Not yet implemented */
    Maturity["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})(Maturity || (Maturity = {}));
/** Add interim support for HTTP methods before a bigger rewrite for Routers as a component */
export var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["UNKNOWN_METHOD"] = "UNKNOWN_METHOD";
    HTTPMethod["GET"] = "GET";
    HTTPMethod["POST"] = "POST";
})(HTTPMethod || (HTTPMethod = {}));
/** The page to which a new widget can be added */
export var InstallPage;
(function (InstallPage) {
    /** Don't add widget to a page */
    InstallPage["NO_PAGE"] = "NO_PAGE";
    /** Add widget to the current page in the editor */
    InstallPage["CURRENT"] = "CURRENT";
    /** Add widget to a new page in the editor */
    InstallPage["PAGE"] = "PAGE";
    /** Add widget to a new lightbox in the editor */
    InstallPage["LIGHTBOX"] = "LIGHTBOX";
})(InstallPage || (InstallPage = {}));
export var RegionType;
(function (RegionType) {
    RegionType["HEADER"] = "HEADER";
    RegionType["BODY"] = "BODY";
    RegionType["FOOTER"] = "FOOTER";
})(RegionType || (RegionType = {}));
export var StaticContainer;
(function (StaticContainer) {
    StaticContainer["UNKNOWN_CONTAINER"] = "UNKNOWN_CONTAINER";
    /** Widget should be installed in the homepage */
    StaticContainer["HOMEPAGE"] = "HOMEPAGE";
})(StaticContainer || (StaticContainer = {}));
/** Category of pages this will be embedded on (single, many, none) */
export var EmbeddedScriptPages;
(function (EmbeddedScriptPages) {
    /** It will not be embedded */
    EmbeddedScriptPages["NONE_PAGES"] = "NONE_PAGES";
    /** It will be embedded once */
    EmbeddedScriptPages["ONCE"] = "ONCE";
    /** It will be embedded multiple times on specific pages */
    EmbeddedScriptPages["SPECIFIC_PAGES"] = "SPECIFIC_PAGES";
})(EmbeddedScriptPages || (EmbeddedScriptPages = {}));
/** Where that embed will be rendered */
export var EmbeddedScriptPlacement;
(function (EmbeddedScriptPlacement) {
    /** It will not be rendered */
    EmbeddedScriptPlacement["NONE_PLACEMENT"] = "NONE_PLACEMENT";
    /** In the document head */
    EmbeddedScriptPlacement["HEAD"] = "HEAD";
    /** Prepended before all children already rendered in the body tag */
    EmbeddedScriptPlacement["BODY_START"] = "BODY_START";
    /** Appended after the last child already rendered in the body tag */
    EmbeddedScriptPlacement["BODY_END"] = "BODY_END";
})(EmbeddedScriptPlacement || (EmbeddedScriptPlacement = {}));
/** Embed category defined for Privacy regulation compliance in EU and CCPA in the US */
export var EmbedCategory;
(function (EmbedCategory) {
    /** Not categorized yet */
    EmbedCategory["UNKNOWN"] = "UNKNOWN";
    /** Must load regardless of policy */
    EmbedCategory["ESSENTIAL"] = "ESSENTIAL";
    /** Adds optional functionality to the site */
    EmbedCategory["FUNCTIONAL"] = "FUNCTIONAL";
    /** Adds analytics abilities to the site */
    EmbedCategory["ANALYTICS"] = "ANALYTICS";
    /** Adds advertising content or advertising tracking to the site */
    EmbedCategory["ADVERTISING"] = "ADVERTISING";
})(EmbedCategory || (EmbedCategory = {}));
export var TemplateDefaultColor;
(function (TemplateDefaultColor) {
    TemplateDefaultColor["BACKGROUND"] = "BACKGROUND";
    TemplateDefaultColor["SECONDARY_TEXTS"] = "SECONDARY_TEXTS";
    TemplateDefaultColor["MAIN_TEXT_AND_ICONS"] = "MAIN_TEXT_AND_ICONS";
    TemplateDefaultColor["BORDERS_AND_DIVIDERS"] = "BORDERS_AND_DIVIDERS";
    TemplateDefaultColor["BUTTONS_AND_LINKS"] = "BUTTONS_AND_LINKS";
})(TemplateDefaultColor || (TemplateDefaultColor = {}));
export var ThumbnailsSize;
(function (ThumbnailsSize) {
    ThumbnailsSize["SMALL"] = "SMALL";
    ThumbnailsSize["MEDIUM"] = "MEDIUM";
    ThumbnailsSize["LARGE"] = "LARGE";
    ThumbnailsSize["XLARGE"] = "XLARGE";
})(ThumbnailsSize || (ThumbnailsSize = {}));
/** Bar alignment selected value */
export var BarAlignmentSelected;
(function (BarAlignmentSelected) {
    BarAlignmentSelected["ALIGN_LEFT"] = "ALIGN_LEFT";
    BarAlignmentSelected["ALIGN_CENTER"] = "ALIGN_CENTER";
    BarAlignmentSelected["ALIGN_RIGHT"] = "ALIGN_RIGHT";
})(BarAlignmentSelected || (BarAlignmentSelected = {}));
export var DefaultTextStyle;
(function (DefaultTextStyle) {
    DefaultTextStyle["TITLE"] = "TITLE";
    DefaultTextStyle["PARAGRAPH"] = "PARAGRAPH";
    DefaultTextStyle["LOWER_HIERARCHY_TEXTS"] = "LOWER_HIERARCHY_TEXTS";
})(DefaultTextStyle || (DefaultTextStyle = {}));
export var ElementType;
(function (ElementType) {
    ElementType["WIDGET"] = "WIDGET";
    ElementType["PAGE"] = "PAGE";
})(ElementType || (ElementType = {}));
export var ScriptType;
(function (ScriptType) {
    ScriptType["NO_SCRIPT_TYPE"] = "NO_SCRIPT_TYPE";
    ScriptType["MODULE"] = "MODULE";
})(ScriptType || (ScriptType = {}));
export var ExtensionType;
(function (ExtensionType) {
    ExtensionType["NONE_EXTENSION"] = "NONE_EXTENSION";
    ExtensionType["PAYMENTS_GATEWAY_EXTENSION"] = "PAYMENTS_GATEWAY_EXTENSION";
    ExtensionType["COUPONS_EXTENSION"] = "COUPONS_EXTENSION";
    ExtensionType["DROPSHIPPING_EXTENSION"] = "DROPSHIPPING_EXTENSION";
    ExtensionType["FULFILMENT_EXTENSION"] = "FULFILMENT_EXTENSION";
    ExtensionType["DROPSHIPPING_SUPPLIER_EXTENSION"] = "DROPSHIPPING_SUPPLIER_EXTENSION";
    ExtensionType["FULFILLMENT_CENTER_EXTENSION"] = "FULFILLMENT_CENTER_EXTENSION";
    ExtensionType["RESTAURANTS_POS_EXTENSION"] = "RESTAURANTS_POS_EXTENSION";
    ExtensionType["ART_STORE_EXTENSION"] = "ART_STORE_EXTENSION";
    ExtensionType["ASCEND_AUTOMATION_EXTENSION"] = "ASCEND_AUTOMATION_EXTENSION";
    ExtensionType["CONTACT_LABELS_EXTENSION"] = "CONTACT_LABELS_EXTENSION";
})(ExtensionType || (ExtensionType = {}));
export var PrimitiveType;
(function (PrimitiveType) {
    PrimitiveType["UNKNOWN_PRIMITIVE_TYPE"] = "UNKNOWN_PRIMITIVE_TYPE";
    PrimitiveType["TEXT"] = "TEXT";
    PrimitiveType["BOOLEAN"] = "BOOLEAN";
    PrimitiveType["NUMBER"] = "NUMBER";
})(PrimitiveType || (PrimitiveType = {}));
export var SimpleType;
(function (SimpleType) {
    SimpleType["UNKNOWN_SIMPLE_TYPE"] = "UNKNOWN_SIMPLE_TYPE";
    SimpleType["MONEY"] = "MONEY";
    SimpleType["LINK"] = "LINK";
    SimpleType["BACKOFFICE_LINK"] = "BACKOFFICE_LINK";
    SimpleType["LIVESITE_LINK"] = "LIVESITE_LINK";
    SimpleType["MULTILINGUAL"] = "MULTILINGUAL";
    SimpleType["IMAGE_LINK"] = "IMAGE_LINK";
    SimpleType["GUID"] = "GUID";
    SimpleType["EMAIL"] = "EMAIL";
    SimpleType["PHONE"] = "PHONE";
    SimpleType["CONTACT_ID"] = "CONTACT_ID";
})(SimpleType || (SimpleType = {}));
export var Exposure;
(function (Exposure) {
    Exposure["UNKNOWN_EXPOSURE"] = "UNKNOWN_EXPOSURE";
    /** Not sent to the action provider */
    Exposure["SETUP"] = "SETUP";
    /** Sent to the action provider and usually hidden from user */
    Exposure["HIDDEN"] = "HIDDEN";
    /** Sent to the action provider and usually shown to user */
    Exposure["EXPOSED"] = "EXPOSED";
})(Exposure || (Exposure = {}));
/** Possible Partial Payment Policy Values */
export var PartialPaymentRestriction;
(function (PartialPaymentRestriction) {
    PartialPaymentRestriction["UNDEFINED"] = "UNDEFINED";
    /** Allow Partial Payment */
    PartialPaymentRestriction["ALLOW"] = "ALLOW";
    /** Disallow Partial Payment */
    PartialPaymentRestriction["DISALLOW"] = "DISALLOW";
})(PartialPaymentRestriction || (PartialPaymentRestriction = {}));
export var HostContainerId;
(function (HostContainerId) {
    HostContainerId["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    HostContainerId["BUSINESS_DASHBOARD_HOST"] = "BUSINESS_DASHBOARD_HOST";
    HostContainerId["SIDEBAR_FOOTER"] = "SIDEBAR_FOOTER";
})(HostContainerId || (HostContainerId = {}));
export var MandatoryField;
(function (MandatoryField) {
    MandatoryField["ZIPCODE"] = "ZIPCODE";
    MandatoryField["CITY"] = "CITY";
    MandatoryField["STATE"] = "STATE";
    MandatoryField["ADDRESS"] = "ADDRESS";
    MandatoryField["COUNTRY_CODE"] = "COUNTRY_CODE";
    MandatoryField["EMAIL"] = "EMAIL";
    MandatoryField["PHONE"] = "PHONE";
    MandatoryField["FIRST_NAME"] = "FIRST_NAME";
    MandatoryField["LAST_NAME"] = "LAST_NAME";
    MandatoryField["STREET"] = "STREET";
    MandatoryField["HOUSE_NUMBER"] = "HOUSE_NUMBER";
    MandatoryField["TAX_IDENTIFIER"] = "TAX_IDENTIFIER";
})(MandatoryField || (MandatoryField = {}));
export var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["Metric"] = "Metric";
    MeasurementSystem["Imperial"] = "Imperial";
})(MeasurementSystem || (MeasurementSystem = {}));
export var Default;
(function (Default) {
    Default["WIX"] = "WIX";
    Default["POS"] = "POS";
})(Default || (Default = {}));
export var HookType;
(function (HookType) {
    HookType["UNDEFINED"] = "UNDEFINED";
    HookType["BEFORE_BLOCKING"] = "BEFORE_BLOCKING";
    HookType["BEFORE"] = "BEFORE";
    HookType["AFTER"] = "AFTER";
})(HookType || (HookType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
    Type["GENERIC"] = "GENERIC";
})(Type || (Type = {}));
export var SourceType;
(function (SourceType) {
    SourceType["UNKNOWN_SOURCE_TYPE"] = "UNKNOWN_SOURCE_TYPE";
    /** The input/output schemas are constructed by developers in Dev Center using the self-service flow */
    SourceType["DEV_CENTER"] = "DEV_CENTER";
    /** The input/output schemas are derived from an existing Wix API through the API-to-Action feature */
    SourceType["WIX_API"] = "WIX_API";
})(SourceType || (SourceType = {}));
export var ExecutionType;
(function (ExecutionType) {
    ExecutionType["UNKNOWN_EXECUTION_TYPE"] = "UNKNOWN_EXECUTION_TYPE";
    ExecutionType["SYNC"] = "SYNC";
    ExecutionType["ASYNC"] = "ASYNC";
})(ExecutionType || (ExecutionType = {}));
/** Which component types can be extended in containers */
export var ExtendingComponentType;
(function (ExtendingComponentType) {
    ExtendingComponentType["INVALID"] = "INVALID";
    ExtendingComponentType["BACK_OFFICE_MENU_ITEM"] = "BACK_OFFICE_MENU_ITEM";
    ExtendingComponentType["BACK_OFFICE_EXTENSION_WIDGET"] = "BACK_OFFICE_EXTENSION_WIDGET";
})(ExtendingComponentType || (ExtendingComponentType = {}));
/** List of back-office hosting platforms */
export var BackOfficeHostingPlatforms;
(function (BackOfficeHostingPlatforms) {
    BackOfficeHostingPlatforms["NO_HOSTING_PLATFORM"] = "NO_HOSTING_PLATFORM";
    /** Site Dashboard (The Wix Dashboard) */
    BackOfficeHostingPlatforms["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    /** User Account Dashboard */
    BackOfficeHostingPlatforms["ACCOUNT_MANAGER"] = "ACCOUNT_MANAGER";
    /** Internal: Dev center */
    BackOfficeHostingPlatforms["DEV_CENTER"] = "DEV_CENTER";
    /** Enterprise dashboard (available to enterprise accounts only) */
    BackOfficeHostingPlatforms["ENTERPRISE"] = "ENTERPRISE";
    /** Partners dashboard (available to partners accounts only) */
    BackOfficeHostingPlatforms["PARTNERS_DASHBOARD"] = "PARTNERS_DASHBOARD";
    /** Employee only financial support dashboard */
    BackOfficeHostingPlatforms["FINANCIALS_INTERNAL_BO"] = "FINANCIALS_INTERNAL_BO";
    /** FED Guild POC dashboard */
    BackOfficeHostingPlatforms["FED_GUILD_POC"] = "FED_GUILD_POC";
    /** Studio dashboard */
    BackOfficeHostingPlatforms["STUDIO_DASHBOARD"] = "STUDIO_DASHBOARD";
    /** Channels dashboard (available to channels accounts only) */
    BackOfficeHostingPlatforms["CHANNELS"] = "CHANNELS";
    /** Wix internal dashboard for data tools (proffesional data consumers, i.e Business Analysts, Data Engineers...) */
    BackOfficeHostingPlatforms["DATA_TOOLS"] = "DATA_TOOLS";
    /** Internal back-office for payment service provider management */
    BackOfficeHostingPlatforms["PSP_BACKOFFICE"] = "PSP_BACKOFFICE";
    /** Rise.ai account dashboard */
    BackOfficeHostingPlatforms["RISE_PLATFORM_ACCOUNT_DASHBOARD"] = "RISE_PLATFORM_ACCOUNT_DASHBOARD";
    /** Enterprise demo dashboard (available to possible enterprise accounts for demo purposes) */
    BackOfficeHostingPlatforms["DEMO_DASHBOARD_ENTERPRISE"] = "DEMO_DASHBOARD_ENTERPRISE";
    /** A new AI scheduling assistant product dashboard (codename: "Nownia") */
    BackOfficeHostingPlatforms["AI_SCHEDULING_ASSISTANT_DASHBOARD"] = "AI_SCHEDULING_ASSISTANT_DASHBOARD";
    /** Employee only getting paid cluster dashboard */
    BackOfficeHostingPlatforms["GETTING_PAID"] = "GETTING_PAID";
    /** Wix internal dashboard for data (non proffesional data consumers, i.e any Wix Employee that has a need for BI data) */
    BackOfficeHostingPlatforms["DATA"] = "DATA";
    /** Dashboard for viral forms/lite events/etc */
    BackOfficeHostingPlatforms["LITE_DASHBOARD"] = "LITE_DASHBOARD";
    /** Picasso AI application POC */
    BackOfficeHostingPlatforms["PICASSO_EDITOR"] = "PICASSO_EDITOR";
    /** Base44 Host Dashboard POC */
    BackOfficeHostingPlatforms["BASE44_DASHBOARD_POC"] = "BASE44_DASHBOARD_POC";
    /** Wixel Editor */
    BackOfficeHostingPlatforms["WIXEL_EDITOR"] = "WIXEL_EDITOR";
})(BackOfficeHostingPlatforms || (BackOfficeHostingPlatforms = {}));
export var DtsDefinitionType;
(function (DtsDefinitionType) {
    DtsDefinitionType["UNKNOWN"] = "UNKNOWN";
    DtsDefinitionType["DTS_HTTP_LINK"] = "DTS_HTTP_LINK";
    DtsDefinitionType["DTS_CONTENT"] = "DTS_CONTENT";
})(DtsDefinitionType || (DtsDefinitionType = {}));
export var SlotDataType;
(function (SlotDataType) {
    SlotDataType["UNKNOWN"] = "UNKNOWN";
    SlotDataType["WIDGET"] = "WIDGET";
    SlotDataType["MENU"] = "MENU";
})(SlotDataType || (SlotDataType = {}));
/** Type attribute for the script tag */
export var BackOfficeScriptAssetType;
(function (BackOfficeScriptAssetType) {
    /** Script will be loaded without a type attribute */
    BackOfficeScriptAssetType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Use "module" as the script type */
    BackOfficeScriptAssetType["MODULE"] = "MODULE";
})(BackOfficeScriptAssetType || (BackOfficeScriptAssetType = {}));
/** View modes for how to open a component. */
export var ViewMode;
(function (ViewMode) {
    /** Opens a page in place of the current page. */
    ViewMode["PAGE"] = "PAGE";
    /** Opens as a modal on the current page. */
    ViewMode["MODAL"] = "MODAL";
})(ViewMode || (ViewMode = {}));
export var AlgorithmType;
(function (AlgorithmType) {
    AlgorithmType["UNSPECIFIED"] = "UNSPECIFIED";
    AlgorithmType["RELATED_ITEMS"] = "RELATED_ITEMS";
    AlgorithmType["GLOBAL"] = "GLOBAL";
})(AlgorithmType || (AlgorithmType = {}));
export var LockableOperation;
(function (LockableOperation) {
    /** When operation lockability is not specified */
    LockableOperation["UNSPECIFIED_LOCKABLE"] = "UNSPECIFIED_LOCKABLE";
    /** Operation is locked */
    LockableOperation["LOCKED"] = "LOCKED";
    /** Operation is unlocked */
    LockableOperation["UNLOCKED"] = "UNLOCKED";
})(LockableOperation || (LockableOperation = {}));
export var RestrictedOperation;
(function (RestrictedOperation) {
    RestrictedOperation["UNSPECIFIED_RESTRICTED"] = "UNSPECIFIED_RESTRICTED";
    RestrictedOperation["ALLOW"] = "ALLOW";
    RestrictedOperation["WARN"] = "WARN";
})(RestrictedOperation || (RestrictedOperation = {}));
export var BlockType;
(function (BlockType) {
    BlockType["UNKNOWN"] = "UNKNOWN";
    BlockType["OR"] = "OR";
    BlockType["AND"] = "AND";
})(BlockType || (BlockType = {}));
export var Domain;
(function (Domain) {
    /** User domain (default) */
    Domain["USER"] = "USER";
    /** Wix domain */
    Domain["WIX"] = "WIX";
})(Domain || (Domain = {}));
export var ApplicationAutomationComponentStatus;
(function (ApplicationAutomationComponentStatus) {
    ApplicationAutomationComponentStatus["ACTIVE"] = "ACTIVE";
    ApplicationAutomationComponentStatus["INACTIVE"] = "INACTIVE";
})(ApplicationAutomationComponentStatus || (ApplicationAutomationComponentStatus = {}));
export var TextInputDisplayType;
(function (TextInputDisplayType) {
    /** A regular text field */
    TextInputDisplayType["TEXT"] = "TEXT";
    /** A password field (where the text is hidden visually) */
    TextInputDisplayType["PASSWORD"] = "PASSWORD";
    /** A field optimized for one time codes */
    TextInputDisplayType["CODE"] = "CODE";
})(TextInputDisplayType || (TextInputDisplayType = {}));
export var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType["UNKNOWN_THUMBNAIL_TYPE"] = "UNKNOWN_THUMBNAIL_TYPE";
    ThumbnailType["IMAGE"] = "IMAGE";
    ThumbnailType["AVATAR"] = "AVATAR";
})(ThumbnailType || (ThumbnailType = {}));
export var ImageShape;
(function (ImageShape) {
    ImageShape["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
    /** Circle */
    ImageShape["CIRCLE"] = "CIRCLE";
    /** Square */
    ImageShape["SQUARE"] = "SQUARE";
    /** Rectangle */
    ImageShape["RECTANGLE"] = "RECTANGLE";
})(ImageShape || (ImageShape = {}));
export var AvatarShape;
(function (AvatarShape) {
    AvatarShape["UNKNOWN_SHAPE"] = "UNKNOWN_SHAPE";
    /** Circle */
    AvatarShape["CIRCLE"] = "CIRCLE";
    /** Square */
    AvatarShape["SQUARE"] = "SQUARE";
})(AvatarShape || (AvatarShape = {}));
export var Tag;
(function (Tag) {
    Tag["UNKNOWN_TAG"] = "UNKNOWN_TAG";
    Tag["EMBEDDABLE"] = "EMBEDDABLE";
    Tag["ECOM_EDIT_ORDER"] = "ECOM_EDIT_ORDER";
    Tag["ECOM_CREATE_ORDER"] = "ECOM_CREATE_ORDER";
    Tag["INBOX"] = "INBOX";
    Tag["ECOM_CREATE_PAY_LINK"] = "ECOM_CREATE_PAY_LINK";
    Tag["ECOM_DELIVERY_PROFILES"] = "ECOM_DELIVERY_PROFILES";
    Tag["ADD_TO_CATEGORY"] = "ADD_TO_CATEGORY";
    Tag["MY_BUSINESS"] = "MY_BUSINESS";
    Tag["PIPELINE_LINKED_ENTITY"] = "PIPELINE_LINKED_ENTITY";
    Tag["GET_PAID"] = "GET_PAID";
    Tag["PIPELINE_CARD_CATALOG_ITEM"] = "PIPELINE_CARD_CATALOG_ITEM";
})(Tag || (Tag = {}));
export var FilterSelectionType;
(function (FilterSelectionType) {
    FilterSelectionType["UNKNOWN_SELECTION"] = "UNKNOWN_SELECTION";
    /** Allow to select only a single item */
    FilterSelectionType["SINGLE_SELECTION"] = "SINGLE_SELECTION";
    /** Allow to select multiple items */
    FilterSelectionType["MULTIPLE_SELECTION"] = "MULTIPLE_SELECTION";
})(FilterSelectionType || (FilterSelectionType = {}));
export var FilterOptionsType;
(function (FilterOptionsType) {
    FilterOptionsType["UNKNOWN_FILTER_OPTIONS"] = "UNKNOWN_FILTER_OPTIONS";
    /** Static hardcoded options */
    FilterOptionsType["STATIC"] = "STATIC";
    FilterOptionsType["PROVIDER"] = "PROVIDER";
})(FilterOptionsType || (FilterOptionsType = {}));
export var PaginationMode;
(function (PaginationMode) {
    PaginationMode["UNKNOWN_PAGINATION_MODE"] = "UNKNOWN_PAGINATION_MODE";
    PaginationMode["CURSOR"] = "CURSOR";
    PaginationMode["OFFSET"] = "OFFSET";
})(PaginationMode || (PaginationMode = {}));
/** The type of the communication channel */
export var ChannelType;
(function (ChannelType) {
    ChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["SMS"] = "SMS";
})(ChannelType || (ChannelType = {}));
export var AcceptedDirectMessageType;
(function (AcceptedDirectMessageType) {
    AcceptedDirectMessageType["TEXT"] = "TEXT";
    AcceptedDirectMessageType["MEDIA"] = "MEDIA";
    AcceptedDirectMessageType["CARD"] = "CARD";
    AcceptedDirectMessageType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    AcceptedDirectMessageType["FORM"] = "FORM";
})(AcceptedDirectMessageType || (AcceptedDirectMessageType = {}));
/** Mime type for relevant media entities in channels */
export var MediaMimeType;
(function (MediaMimeType) {
    MediaMimeType["UNKNOWN_MIME_TYPE"] = "UNKNOWN_MIME_TYPE";
    MediaMimeType["IMAGE_JPEG"] = "IMAGE_JPEG";
    MediaMimeType["IMAGE_PNG"] = "IMAGE_PNG";
    MediaMimeType["IMAGE_WEBP"] = "IMAGE_WEBP";
    MediaMimeType["VIDEO_MPEG"] = "VIDEO_MPEG";
    MediaMimeType["VIDEO_MP4"] = "VIDEO_MP4";
    MediaMimeType["VIDEO_3GP"] = "VIDEO_3GP";
    MediaMimeType["AUDIO_AAC"] = "AUDIO_AAC";
    MediaMimeType["AUDIO_MP4"] = "AUDIO_MP4";
    MediaMimeType["AUDIO_MPEG"] = "AUDIO_MPEG";
    MediaMimeType["AUDIO_OGG"] = "AUDIO_OGG";
    MediaMimeType["AUDIO_OPUS"] = "AUDIO_OPUS";
    MediaMimeType["APPLICATION_PDF"] = "APPLICATION_PDF";
    MediaMimeType["APPLICATION_OCTET_STREAM"] = "APPLICATION_OCTET_STREAM";
})(MediaMimeType || (MediaMimeType = {}));
export var AcceptedSmsMessageType;
(function (AcceptedSmsMessageType) {
    AcceptedSmsMessageType["SMS"] = "SMS";
    AcceptedSmsMessageType["MMS"] = "MMS";
})(AcceptedSmsMessageType || (AcceptedSmsMessageType = {}));
export var InitDirection;
(function (InitDirection) {
    InitDirection["UNKNOWN_INIT_DIRECTION"] = "UNKNOWN_INIT_DIRECTION";
    InitDirection["BUSINESS"] = "BUSINESS";
    InitDirection["CUSTOMER"] = "CUSTOMER";
    InitDirection["BOTH"] = "BOTH";
})(InitDirection || (InitDirection = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    /** @deprecated */
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
    NodeType["CAPTION"] = "CAPTION";
    NodeType["LAYOUT"] = "LAYOUT";
    NodeType["LAYOUT_CELL"] = "LAYOUT_CELL";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var ButtonDataType;
(function (ButtonDataType) {
    /** Regular link button */
    ButtonDataType["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    ButtonDataType["ACTION"] = "ACTION";
})(ButtonDataType || (ButtonDataType = {}));
export var LinkTarget;
(function (LinkTarget) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    LinkTarget["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    LinkTarget["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    LinkTarget["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    LinkTarget["TOP"] = "TOP";
})(LinkTarget || (LinkTarget = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var DividerDataWidth;
(function (DividerDataWidth) {
    /** Large line */
    DividerDataWidth["LARGE"] = "LARGE";
    /** Medium line */
    DividerDataWidth["MEDIUM"] = "MEDIUM";
    /** Small line */
    DividerDataWidth["SMALL"] = "SMALL";
})(DividerDataWidth || (DividerDataWidth = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var PDFSettingsViewMode;
(function (PDFSettingsViewMode) {
    /** No PDF view */
    PDFSettingsViewMode["NONE"] = "NONE";
    /** Full PDF view */
    PDFSettingsViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    PDFSettingsViewMode["MINI"] = "MINI";
})(PDFSettingsViewMode || (PDFSettingsViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var GIFType;
(function (GIFType) {
    GIFType["NORMAL"] = "NORMAL";
    GIFType["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var StylesPosition;
(function (StylesPosition) {
    /** Thumbnail positioned at the start (left in LTR layouts, right in RTL layouts) */
    StylesPosition["START"] = "START";
    /** Thumbnail positioned at the end (right in LTR layouts, left in RTL layouts) */
    StylesPosition["END"] = "END";
    /** Thumbnail positioned at the top */
    StylesPosition["TOP"] = "TOP";
    /** Thumbnail hidden and not displayed */
    StylesPosition["HIDDEN"] = "HIDDEN";
})(StylesPosition || (StylesPosition = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
    DecorationType["STRIKETHROUGH"] = "STRIKETHROUGH";
    DecorationType["SUPERSCRIPT"] = "SUPERSCRIPT";
    DecorationType["SUBSCRIPT"] = "SUBSCRIPT";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var ImageStylesPosition;
(function (ImageStylesPosition) {
    /** Image positioned at the start (left in LTR layouts, right in RTL layouts) */
    ImageStylesPosition["START"] = "START";
    /** Image positioned at the end (right in LTR layouts, left in RTL layouts) */
    ImageStylesPosition["END"] = "END";
    /** Image positioned at the top */
    ImageStylesPosition["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
export var AspectRatio;
(function (AspectRatio) {
    /** 1:1 aspect ratio */
    AspectRatio["SQUARE"] = "SQUARE";
    /** 16:9 aspect ratio */
    AspectRatio["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
export var Resizing;
(function (Resizing) {
    /** Fill the container, may crop the image */
    Resizing["FILL"] = "FILL";
    /** Fit the image within the container */
    Resizing["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
export var Placement;
(function (Placement) {
    /** Ribbon placed on the image */
    Placement["IMAGE"] = "IMAGE";
    /** Ribbon placed on the product information */
    Placement["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
export var CardStylesType;
(function (CardStylesType) {
    /** Card with visible border and background */
    CardStylesType["CONTAINED"] = "CONTAINED";
    /** Card without visible border */
    CardStylesType["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
export var CardStylesAlignment;
(function (CardStylesAlignment) {
    /** Content aligned to start (left in LTR layouts, right in RTL layouts) */
    CardStylesAlignment["START"] = "START";
    /** Content centered */
    CardStylesAlignment["CENTER"] = "CENTER";
    /** Content aligned to end (right in LTR layouts, left in RTL layouts) */
    CardStylesAlignment["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
export var CardStylesLayout;
(function (CardStylesLayout) {
    /** Elements stacked vertically */
    CardStylesLayout["STACKED"] = "STACKED";
    /** Elements arranged horizontally */
    CardStylesLayout["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var CalendarType;
(function (CalendarType) {
    CalendarType["UNDEFINED"] = "UNDEFINED";
    CalendarType["GOOGLE"] = "GOOGLE";
    CalendarType["I_CAL"] = "I_CAL";
    CalendarType["MICROSOFT"] = "MICROSOFT";
    CalendarType["OTHER"] = "OTHER";
})(CalendarType || (CalendarType = {}));
export var ConnectMethod;
(function (ConnectMethod) {
    ConnectMethod["OAUTH"] = "OAUTH";
    ConnectMethod["CREDENTIALS"] = "CREDENTIALS";
})(ConnectMethod || (ConnectMethod = {}));
export var ListEventFromCalendars;
(function (ListEventFromCalendars) {
    /** Listing events from the external calendar is not supported. */
    ListEventFromCalendars["LIST_NOT_SUPPORTED"] = "LIST_NOT_SUPPORTED";
    /** Listing events from the primary external calendar only. */
    ListEventFromCalendars["LIST_FROM_PRIMARY_CALENDAR_ONLY"] = "LIST_FROM_PRIMARY_CALENDAR_ONLY";
    /**
     * Listing events from specific external calendars.
     * The external calendars can be listed using the `ExternalCalendarProvider.ListCalendars` API.
     */
    ListEventFromCalendars["LIST_FROM_SPECIFIC_CALENDARS"] = "LIST_FROM_SPECIFIC_CALENDARS";
})(ListEventFromCalendars || (ListEventFromCalendars = {}));
export var SyncToCalendar;
(function (SyncToCalendar) {
    /** Syncing Wix calendar sessions to the external calendar is not supported. */
    SyncToCalendar["SYNC_NOT_SUPPORTED"] = "SYNC_NOT_SUPPORTED";
    /** Syncing Wix calendar sessions to the primary external calendar only. */
    SyncToCalendar["SYNC_TO_PRIMARY_CALENDAR_ONLY"] = "SYNC_TO_PRIMARY_CALENDAR_ONLY";
    /** Syncing Wix calendar sessions to a new external calendar. */
    SyncToCalendar["SYNC_TO_DEDICATED_CALENDAR"] = "SYNC_TO_DEDICATED_CALENDAR";
})(SyncToCalendar || (SyncToCalendar = {}));
/** Types of OAuth application. */
export var OAuthAppType;
(function (OAuthAppType) {
    /** OAuth app type is not specified. */
    OAuthAppType["OAUTH_APP_TYPE_UNSPECIFIED"] = "OAUTH_APP_TYPE_UNSPECIFIED";
    /** OAuth app type is a web application. */
    OAuthAppType["WEB_APP"] = "WEB_APP";
    /** OAuth app type is a mobile application. */
    OAuthAppType["MOBILE"] = "MOBILE";
    /** OAuth app type is some other type of application. */
    OAuthAppType["OTHER"] = "OTHER";
})(OAuthAppType || (OAuthAppType = {}));
/** OAuth technology used by the oauth application. */
export var OAuthTechnologies;
(function (OAuthTechnologies) {
    /** The OAuth technology is not specified. */
    OAuthTechnologies["OAUTH_TECHNOLOGY_UNSPECIFIED"] = "OAUTH_TECHNOLOGY_UNSPECIFIED";
    /** OAuth technology using JavaScript. */
    OAuthTechnologies["JAVASCRIPT"] = "JAVASCRIPT";
    /** OAuth technology using Angular. */
    OAuthTechnologies["ANGULAR"] = "ANGULAR";
    /** OAuth technology using Vue.js. */
    OAuthTechnologies["VUE"] = "VUE";
    /** OAuth technology using React. */
    OAuthTechnologies["REACT"] = "REACT";
    /** OAuth technology using React Native. */
    OAuthTechnologies["REACT_NATIVE"] = "REACT_NATIVE";
    /** OAuth technology using iOS. */
    OAuthTechnologies["IOS"] = "IOS";
    /** OAuth technology using Android. */
    OAuthTechnologies["ANDROID"] = "ANDROID";
    /** OAuth technology using some other kind of technology. */
    OAuthTechnologies["OTHER_TECHNOLOGY"] = "OTHER_TECHNOLOGY";
})(OAuthTechnologies || (OAuthTechnologies = {}));
export var NavigationType;
(function (NavigationType) {
    NavigationType["NAVIGATE"] = "NAVIGATE";
    NavigationType["MODAL"] = "MODAL";
})(NavigationType || (NavigationType = {}));
export var State;
(function (State) {
    State["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    State["DEFAULT_ON"] = "DEFAULT_ON";
    State["DEFAULT_OFF"] = "DEFAULT_OFF";
    State["ALWAYS_ON"] = "ALWAYS_ON";
})(State || (State = {}));
export var NotificationTopicState;
(function (NotificationTopicState) {
    NotificationTopicState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    NotificationTopicState["DEFAULT_ON"] = "DEFAULT_ON";
    NotificationTopicState["DEFAULT_OFF"] = "DEFAULT_OFF";
    NotificationTopicState["ALWAYS_ON"] = "ALWAYS_ON";
})(NotificationTopicState || (NotificationTopicState = {}));
export var NotificationTopicType;
(function (NotificationTopicType) {
    NotificationTopicType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    NotificationTopicType["PROMOTIONAL"] = "PROMOTIONAL";
    NotificationTopicType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(NotificationTopicType || (NotificationTopicType = {}));
/** Recipient type */
export var RecipientType;
(function (RecipientType) {
    RecipientType["UNKNOWN_RECIPIENT_TYPE"] = "UNKNOWN_RECIPIENT_TYPE";
    /** Wix User */
    RecipientType["WIX_USER"] = "WIX_USER";
    /** Contact */
    RecipientType["CONTACT"] = "CONTACT";
})(RecipientType || (RecipientType = {}));
export var PlanFormPricingOption;
(function (PlanFormPricingOption) {
    PlanFormPricingOption["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
    PlanFormPricingOption["FREE"] = "FREE";
    PlanFormPricingOption["ONE_TIME"] = "ONE_TIME";
    PlanFormPricingOption["RECURRING"] = "RECURRING";
})(PlanFormPricingOption || (PlanFormPricingOption = {}));
export var PlanFormDefaultSection;
(function (PlanFormDefaultSection) {
    PlanFormDefaultSection["UNKNWON_PLAN_FORM_SECTION"] = "UNKNWON_PLAN_FORM_SECTION";
    PlanFormDefaultSection["INFO"] = "INFO";
    PlanFormDefaultSection["BENEFITS"] = "BENEFITS";
    PlanFormDefaultSection["PAGE_PERMISSIONS"] = "PAGE_PERMISSIONS";
    PlanFormDefaultSection["PRICING_AND_DURATION"] = "PRICING_AND_DURATION";
    PlanFormDefaultSection["ADVANCED_SETTINGS"] = "ADVANCED_SETTINGS";
})(PlanFormDefaultSection || (PlanFormDefaultSection = {}));
/** Pedefined basic time unit. */
export var PlanPeriodUnit;
(function (PlanPeriodUnit) {
    PlanPeriodUnit["UNDEFINED"] = "UNDEFINED";
    PlanPeriodUnit["DAY"] = "DAY";
    PlanPeriodUnit["WEEK"] = "WEEK";
    PlanPeriodUnit["MONTH"] = "MONTH";
    PlanPeriodUnit["YEAR"] = "YEAR";
})(PlanPeriodUnit || (PlanPeriodUnit = {}));
export var TypedDynamicParamType;
(function (TypedDynamicParamType) {
    TypedDynamicParamType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    TypedDynamicParamType["STRING"] = "STRING";
    TypedDynamicParamType["ARRAY"] = "ARRAY";
})(TypedDynamicParamType || (TypedDynamicParamType = {}));
export var UserNotificationDataRecipientFilterType;
(function (UserNotificationDataRecipientFilterType) {
    UserNotificationDataRecipientFilterType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataRecipientFilterType["WIX_USERS"] = "WIX_USERS";
    UserNotificationDataRecipientFilterType["SITE_CONTRIBUTORS"] = "SITE_CONTRIBUTORS";
})(UserNotificationDataRecipientFilterType || (UserNotificationDataRecipientFilterType = {}));
export var UserNotificationDataInitiatorType;
(function (UserNotificationDataInitiatorType) {
    UserNotificationDataInitiatorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataInitiatorType["WIX_USER"] = "WIX_USER";
    UserNotificationDataInitiatorType["WIX_APP"] = "WIX_APP";
})(UserNotificationDataInitiatorType || (UserNotificationDataInitiatorType = {}));
export var Level;
(function (Level) {
    Level["UNKNOWN_LEVEL"] = "UNKNOWN_LEVEL";
    Level["ACCOUNT"] = "ACCOUNT";
    Level["USER"] = "USER";
    Level["SITE"] = "SITE";
})(Level || (Level = {}));
export var IconType;
(function (IconType) {
    IconType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    IconType["URL"] = "URL";
    IconType["SPOUT"] = "SPOUT";
    IconType["INITIATOR"] = "INITIATOR";
})(IconType || (IconType = {}));
export var MobileApplication;
(function (MobileApplication) {
    MobileApplication["UNKNOWN_MOBILE_APPLICATION"] = "UNKNOWN_MOBILE_APPLICATION";
    MobileApplication["OWNER"] = "OWNER";
    MobileApplication["SPACES"] = "SPACES";
    MobileApplication["DINE"] = "DINE";
    MobileApplication["FITNESS"] = "FITNESS";
    MobileApplication["WIX_LIFE"] = "WIX_LIFE";
    MobileApplication["WIX_PARTNERS"] = "WIX_PARTNERS";
    MobileApplication["BRANDED"] = "BRANDED";
    MobileApplication["WIX_STUDIO"] = "WIX_STUDIO";
    MobileApplication["NO_SPECIFIC_TARGET_APP"] = "NO_SPECIFIC_TARGET_APP";
})(MobileApplication || (MobileApplication = {}));
export var AndroidStyle;
(function (AndroidStyle) {
    AndroidStyle["UNKNOWN_ANDROID_STYLE"] = "UNKNOWN_ANDROID_STYLE";
    AndroidStyle["BIG_TEXT"] = "BIG_TEXT";
    AndroidStyle["MESSAGING"] = "MESSAGING";
    AndroidStyle["INBOX"] = "INBOX";
})(AndroidStyle || (AndroidStyle = {}));
export var ExposureRuleType;
(function (ExposureRuleType) {
    ExposureRuleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ExposureRuleType["OPEN_TO_ALL"] = "OPEN_TO_ALL";
    ExposureRuleType["OPEN_TO_NONE"] = "OPEN_TO_NONE";
    ExposureRuleType["BOOLEAN_EXPERIMENT"] = "BOOLEAN_EXPERIMENT";
    ExposureRuleType["CUSTOM_EXPERIMENT"] = "CUSTOM_EXPERIMENT";
})(ExposureRuleType || (ExposureRuleType = {}));
export var Intent;
(function (Intent) {
    Intent["UNKNOWN_INTENT"] = "UNKNOWN_INTENT";
    Intent["MARKETING"] = "MARKETING";
    Intent["TRANSACTIONAL"] = "TRANSACTIONAL";
})(Intent || (Intent = {}));
export var UserNotificationDataType;
(function (UserNotificationDataType) {
    UserNotificationDataType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    UserNotificationDataType["REGULAR"] = "REGULAR";
    UserNotificationDataType["ALERT_WARNING"] = "ALERT_WARNING";
    UserNotificationDataType["ALERT_INFO"] = "ALERT_INFO";
})(UserNotificationDataType || (UserNotificationDataType = {}));
export var RecipientFilterType;
(function (RecipientFilterType) {
    RecipientFilterType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    RecipientFilterType["CONTACTS"] = "CONTACTS";
})(RecipientFilterType || (RecipientFilterType = {}));
export var InitiatorType;
(function (InitiatorType) {
    InitiatorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    InitiatorType["CONTACT"] = "CONTACT";
    InitiatorType["SITE_MEMBER"] = "SITE_MEMBER";
})(InitiatorType || (InitiatorType = {}));
export var Environment;
(function (Environment) {
    Environment["LIVE_SITE"] = "LIVE_SITE";
    Environment["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
})(Environment || (Environment = {}));
export var SchemaScope;
(function (SchemaScope) {
    SchemaScope["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
    /** Global schema for all sites. */
    SchemaScope["GLOBAL"] = "GLOBAL";
    /** Custom schema for a specific site. */
    SchemaScope["SITE"] = "SITE";
})(SchemaScope || (SchemaScope = {}));
export var FieldType;
(function (FieldType) {
    /** Undefined field type */
    FieldType["UNDEFINED_TYPE"] = "UNDEFINED_TYPE";
    /** Short plain text displayed as a single line in the UI. */
    FieldType["SHORT_TEXT"] = "SHORT_TEXT";
    /** Long plain text displayed as multiple lines in the UI. */
    FieldType["LONG_TEXT"] = "LONG_TEXT";
    /** Long text including styles, images, and links. */
    FieldType["HTML"] = "HTML";
    /** Rich-Content using the Wix Ricos format. */
    FieldType["RICH_CONTENT"] = "RICH_CONTENT";
    /** Wix Media Manager image. */
    FieldType["IMAGE"] = "IMAGE";
    /** Image URL without metadata. */
    FieldType["IMAGE_LINK"] = "IMAGE_LINK";
    /** Contains an XML representation of an entity or part of it. */
    FieldType["JSON"] = "JSON";
    /** Wix Media Manager video. */
    FieldType["VIDEO"] = "VIDEO";
    /** Wix Media Manager document. */
    FieldType["DOCUMENT"] = "DOCUMENT";
})(FieldType || (FieldType = {}));
export var CustomElementScriptType;
(function (CustomElementScriptType) {
    CustomElementScriptType["NONE"] = "NONE";
    /** CommonJS modularization approach */
    CustomElementScriptType["COMMON_JS"] = "COMMON_JS";
    /** ES Module modularization approach */
    CustomElementScriptType["ES_MODULE"] = "ES_MODULE";
})(CustomElementScriptType || (CustomElementScriptType = {}));
export var HeightMode;
(function (HeightMode) {
    HeightMode["UNKNOWN"] = "UNKNOWN";
    /** Height is calculated by content */
    HeightMode["AUTO"] = "AUTO";
    /** Height is fixed require size in px */
    HeightMode["FIXED"] = "FIXED";
})(HeightMode || (HeightMode = {}));
export var FieldFieldType;
(function (FieldFieldType) {
    FieldFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    FieldFieldType["INPUT"] = "INPUT";
    FieldFieldType["DISPLAY"] = "DISPLAY";
})(FieldFieldType || (FieldFieldType = {}));
export var Format;
(function (Format) {
    Format["UNKNOWN_FORMAT"] = "UNKNOWN_FORMAT";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var StringComponentType;
(function (StringComponentType) {
    StringComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    StringComponentType["DATE_TIME"] = "DATE_TIME";
    StringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
    StringComponentType["DATE_INPUT"] = "DATE_INPUT";
    StringComponentType["TIME_INPUT"] = "TIME_INPUT";
    StringComponentType["DATE_PICKER"] = "DATE_PICKER";
})(StringComponentType || (StringComponentType = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    /** Undefined number of columns. */
    NumberOfColumns["UNKNOWN"] = "UNKNOWN";
    /** Zero columns. */
    NumberOfColumns["ZERO"] = "ZERO";
    /** One column. */
    NumberOfColumns["ONE"] = "ONE";
    /** Two columns. */
    NumberOfColumns["TWO"] = "TWO";
    /** Three columns. */
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var FirstDayOfWeek;
(function (FirstDayOfWeek) {
    /** First day of the week is Monday. */
    FirstDayOfWeek["MONDAY"] = "MONDAY";
    /** First day of the week is Sunday. */
    FirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    NumberComponentType["UNKNOWN"] = "UNKNOWN";
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    NumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    BooleanComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    ItemType["UNKNOWN_ITEM_TYPE"] = "UNKNOWN_ITEM_TYPE";
    ItemType["STRING"] = "STRING";
    ItemType["NUMBER"] = "NUMBER";
    ItemType["BOOLEAN"] = "BOOLEAN";
    ItemType["INTEGER"] = "INTEGER";
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypeEnum;
(function (PropertiesTypeEnum) {
    PropertiesTypeEnum["UNKNOWN_PROPERTY_TYPE"] = "UNKNOWN_PROPERTY_TYPE";
    PropertiesTypeEnum["STRING"] = "STRING";
    PropertiesTypeEnum["NUMBER"] = "NUMBER";
    PropertiesTypeEnum["BOOLEAN"] = "BOOLEAN";
    PropertiesTypeEnum["INTEGER"] = "INTEGER";
    PropertiesTypeEnum["ARRAY"] = "ARRAY";
})(PropertiesTypeEnum || (PropertiesTypeEnum = {}));
export var ArrayComponentType;
(function (ArrayComponentType) {
    ArrayComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    ArrayComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
})(ArrayComponentType || (ArrayComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    WixFileComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    WixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    /** Undefined upload file format. */
    UploadFileFormat["UNDEFINED"] = "UNDEFINED";
    /** Video files. */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files. */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files. */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files. */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
    /** Archive files. */
    UploadFileFormat["ARCHIVE"] = "ARCHIVE";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    PaymentComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    PaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
})(PaymentComponentType || (PaymentComponentType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["UNKNOWN"] = "UNKNOWN";
    /** Shippable (physical). */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    PriceType["UNKNOWN"] = "UNKNOWN";
    /** Fixed price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Dynamic price from price range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var ImageFit;
(function (ImageFit) {
    ImageFit["UNKNOWN_IMAGE_FIT"] = "UNKNOWN_IMAGE_FIT";
    /** Image is scaled to maintain its aspect ratio while filling the element's entire content box. Portions of the image may be clipped if the aspect ratios do not match. */
    ImageFit["COVER"] = "COVER";
    /** Image is resized to fill the element's content box. Aspect ratio may not be preserved. */
    ImageFit["CONTAIN"] = "CONTAIN";
})(ImageFit || (ImageFit = {}));
export var MultilineAddressComponentType;
(function (MultilineAddressComponentType) {
    MultilineAddressComponentType["UNKNOWN_COMPONENT_TYPE"] = "UNKNOWN_COMPONENT_TYPE";
    MultilineAddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(MultilineAddressComponentType || (MultilineAddressComponentType = {}));
export var DefaultCountryConfigType;
(function (DefaultCountryConfigType) {
    /** Unknown default country config type. */
    DefaultCountryConfigType["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country is determined by customer's IP address. */
    DefaultCountryConfigType["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    DefaultCountryConfigType["COUNTRY"] = "COUNTRY";
})(DefaultCountryConfigType || (DefaultCountryConfigType = {}));
export var InputType;
(function (InputType) {
    InputType["UNKNOWN_INPUT_TYPE"] = "UNKNOWN_INPUT_TYPE";
    InputType["STRING"] = "STRING";
    InputType["NUMBER"] = "NUMBER";
    InputType["BOOLEAN"] = "BOOLEAN";
    InputType["ARRAY"] = "ARRAY";
    InputType["OBJECT"] = "OBJECT";
    InputType["WIX_FILE"] = "WIX_FILE";
    InputType["PAYMENT"] = "PAYMENT";
    InputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(InputType || (InputType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var AddressInfoTag;
(function (AddressInfoTag) {
    AddressInfoTag["UNTAGGED"] = "UNTAGGED";
    AddressInfoTag["HOME"] = "HOME";
})(AddressInfoTag || (AddressInfoTag = {}));
export var ConfirmationLevel;
(function (ConfirmationLevel) {
    ConfirmationLevel["UNKNOWN_CONFIRMATION_LEVEL"] = "UNKNOWN_CONFIRMATION_LEVEL";
    ConfirmationLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    ConfirmationLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(ConfirmationLevel || (ConfirmationLevel = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNKNOWN_CONTACT_FIELD"] = "UNKNOWN_CONTACT_FIELD";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var DisplayFieldType;
(function (DisplayFieldType) {
    DisplayFieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    DisplayFieldType["RICH_CONTENT"] = "RICH_CONTENT";
    DisplayFieldType["PAGE_NAVIGATION"] = "PAGE_NAVIGATION";
    DisplayFieldType["LOGIN_BAR"] = "LOGIN_BAR";
})(DisplayFieldType || (DisplayFieldType = {}));
/** Enum for different types of changeable properties. */
export var ChangeableProperty;
(function (ChangeableProperty) {
    /** Unknown property type. */
    ChangeableProperty["UNKNOWN"] = "UNKNOWN";
    /** Required property type. */
    ChangeableProperty["REQUIRED"] = "REQUIRED";
    /** Hidden property type. */
    ChangeableProperty["HIDDEN"] = "HIDDEN";
    /** Allowed values property type. */
    ChangeableProperty["ALLOWED_VALUES"] = "ALLOWED_VALUES";
})(ChangeableProperty || (ChangeableProperty = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    OverrideEntityType["FIELD"] = "FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Operator;
(function (Operator) {
    Operator["UNKNOWN"] = "UNKNOWN";
    Operator["EQUAL"] = "EQUAL";
    Operator["NOT_EQUAL"] = "NOT_EQUAL";
    Operator["EMPTY"] = "EMPTY";
    Operator["NOT_EMPTY"] = "NOT_EMPTY";
    Operator["CONTAINS"] = "CONTAINS";
    Operator["NOT_CONTAINS"] = "NOT_CONTAINS";
    Operator["LESS_THAN"] = "LESS_THAN";
    Operator["LESS_THAN_OR_EQUALS"] = "LESS_THAN_OR_EQUALS";
    Operator["GREATER_THAN"] = "GREATER_THAN";
    Operator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    Operator["BEFORE"] = "BEFORE";
    Operator["BEFORE_OR_EQUAL"] = "BEFORE_OR_EQUAL";
    Operator["AFTER"] = "AFTER";
    Operator["AFTER_OR_EQUAL"] = "AFTER_OR_EQUAL";
    Operator["BETWEEN"] = "BETWEEN";
    Operator["ANY"] = "ANY";
    Operator["ARRAY_EQUAL"] = "ARRAY_EQUAL";
    Operator["ARRAY_NOT_EQUAL"] = "ARRAY_NOT_EQUAL";
    Operator["CHECKED"] = "CHECKED";
    Operator["NOT_CHECKED"] = "NOT_CHECKED";
    Operator["IN"] = "IN";
    Operator["NOT_IN"] = "NOT_IN";
    Operator["IS_DATE_OLDER_THAN"] = "IS_DATE_OLDER_THAN";
    Operator["IS_DATE_OLDER_THAN_OR_EQUAL"] = "IS_DATE_OLDER_THAN_OR_EQUAL";
    Operator["IS_DATE_NEWER_THAN"] = "IS_DATE_NEWER_THAN";
    Operator["IS_DATE_NEWER_THAN_OR_EQUAL"] = "IS_DATE_NEWER_THAN_OR_EQUAL";
})(Operator || (Operator = {}));
export var Target;
(function (Target) {
    Target["UNKNOWN_TARGET"] = "UNKNOWN_TARGET";
    /** Open in the same browser tab. */
    Target["SELF"] = "SELF";
    /** Open in a new browser tab. */
    Target["BLANK"] = "BLANK";
})(Target || (Target = {}));
export var SubmitSuccessAction;
(function (SubmitSuccessAction) {
    SubmitSuccessAction["UNKNOWN_SUBMIT_SUCCESS_ACTION"] = "UNKNOWN_SUBMIT_SUCCESS_ACTION";
    /** No action will be taken after submission. */
    SubmitSuccessAction["NO_ACTION"] = "NO_ACTION";
    /** A thank you message will be shown after submission. */
    SubmitSuccessAction["THANK_YOU_MESSAGE"] = "THANK_YOU_MESSAGE";
    /** The user will be redirected to a URL after submission. */
    SubmitSuccessAction["REDIRECT"] = "REDIRECT";
})(SubmitSuccessAction || (SubmitSuccessAction = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["UNKNOWN"] = "UNKNOWN";
    /** a template, which can be extended by a site specific form with custom properties */
    TemplateType["EXTENDABLE"] = "EXTENDABLE";
    /** a template, from which a demo form is created */
    TemplateType["DEMO"] = "DEMO";
    /**
     * a form input, having more than one field.
     * E.g. address (country, state, street, postal code), or phone number (country code, number)
     */
    TemplateType["FORM_INPUT"] = "FORM_INPUT";
})(TemplateType || (TemplateType = {}));
export var CustomFieldsType;
(function (CustomFieldsType) {
    /** Allow user to add/remove any custom field, not present in template */
    CustomFieldsType["ANY"] = "ANY";
})(CustomFieldsType || (CustomFieldsType = {}));
export var EditableProperties;
(function (EditableProperties) {
    EditableProperties["UNKNOWN"] = "UNKNOWN";
    /** Change property responsible for field requirement */
    EditableProperties["REQUIRED"] = "REQUIRED";
    /** Change property responsible for field visibility */
    EditableProperties["HIDDEN"] = "HIDDEN";
    /** Change property of field label */
    EditableProperties["LABEL"] = "LABEL";
    /** Change property of field placeholder */
    EditableProperties["PLACEHOLDER"] = "PLACEHOLDER";
    /** Change property of field description */
    EditableProperties["DESCRIPTION"] = "DESCRIPTION";
    /**
     * Change property of validation specifying max/min boundaries for input value
     * maxLength/minLength for string, max/min for number.
     */
    EditableProperties["INPUT_VALUE_LIMITS"] = "INPUT_VALUE_LIMITS";
    /** Change property responsible for field default value */
    EditableProperties["DEFAULT_VALUE"] = "DEFAULT_VALUE";
})(EditableProperties || (EditableProperties = {}));
export var RequiredIndicator;
(function (RequiredIndicator) {
    /** Unknown required indicator. */
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Asterisk (*). */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Text (default: "Required"). */
    RequiredIndicator["TEXT"] = "TEXT";
    /** None. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    /** Unknown required indicator placement. */
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** After field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Before field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var WixCodePublishTaskName;
(function (WixCodePublishTaskName) {
    /** unknown */
    WixCodePublishTaskName["UNKNOWN"] = "UNKNOWN";
    /** user code bundle */
    WixCodePublishTaskName["USER_CODE_BUNDLE"] = "USER_CODE_BUNDLE";
    /** exported functions analysis */
    WixCodePublishTaskName["EXPORTED_FUNCTIONS_ANALYSIS"] = "EXPORTED_FUNCTIONS_ANALYSIS";
    /** imported namespaces analysis */
    WixCodePublishTaskName["IMPORTED_NAMESPACES_ANALYSIS"] = "IMPORTED_NAMESPACES_ANALYSIS";
    /** page details analysis */
    WixCodePublishTaskName["PAGE_DETAILS_ANALYSIS"] = "PAGE_DETAILS_ANALYSIS";
    /** user code validation */
    WixCodePublishTaskName["USER_CODE_VALIDATION"] = "USER_CODE_VALIDATION";
    /** code packages dependencies registration */
    WixCodePublishTaskName["CODE_PACKAGES_REGISTRATION"] = "CODE_PACKAGES_REGISTRATION";
})(WixCodePublishTaskName || (WixCodePublishTaskName = {}));
/** The type of the communication channel */
export var ChannelConfigurationChannelType;
(function (ChannelConfigurationChannelType) {
    ChannelConfigurationChannelType["UNKNOWN_CHANNEL_TYPE"] = "UNKNOWN_CHANNEL_TYPE";
    ChannelConfigurationChannelType["DIRECT_MESSAGING"] = "DIRECT_MESSAGING";
    ChannelConfigurationChannelType["EMAIL"] = "EMAIL";
    ChannelConfigurationChannelType["SMS"] = "SMS";
})(ChannelConfigurationChannelType || (ChannelConfigurationChannelType = {}));
/** 'TEXT' type is assumed to be always supported, hence not explicitly annotated. */
export var AcceptedMessageTypesAcceptedDirectMessageType;
(function (AcceptedMessageTypesAcceptedDirectMessageType) {
    AcceptedMessageTypesAcceptedDirectMessageType["UNKNOWN_DIRECT_MESSAGE_TYPE"] = "UNKNOWN_DIRECT_MESSAGE_TYPE";
    AcceptedMessageTypesAcceptedDirectMessageType["MEDIA"] = "MEDIA";
    AcceptedMessageTypesAcceptedDirectMessageType["CARD"] = "CARD";
    AcceptedMessageTypesAcceptedDirectMessageType["MINIMAL"] = "MINIMAL";
    AcceptedMessageTypesAcceptedDirectMessageType["FORM"] = "FORM";
    AcceptedMessageTypesAcceptedDirectMessageType["SYSTEM"] = "SYSTEM";
})(AcceptedMessageTypesAcceptedDirectMessageType || (AcceptedMessageTypesAcceptedDirectMessageType = {}));
export var AcceptedMessageTypesAcceptedSmsMessageType;
(function (AcceptedMessageTypesAcceptedSmsMessageType) {
    AcceptedMessageTypesAcceptedSmsMessageType["UNKNOWN_SMS_MESSAGE_TYPE"] = "UNKNOWN_SMS_MESSAGE_TYPE";
    AcceptedMessageTypesAcceptedSmsMessageType["SMS"] = "SMS";
    AcceptedMessageTypesAcceptedSmsMessageType["MMS"] = "MMS";
})(AcceptedMessageTypesAcceptedSmsMessageType || (AcceptedMessageTypesAcceptedSmsMessageType = {}));
export var FactorType;
(function (FactorType) {
    /** Unknown factor type. */
    FactorType["UNKNOWN_FACTOR_TYPE"] = "UNKNOWN_FACTOR_TYPE";
    /** Requires a password. */
    FactorType["PASSWORD"] = "PASSWORD";
    /** Requires a code sent via SMS. */
    FactorType["SMS"] = "SMS";
    /** Requires a code sent by phone call. */
    FactorType["CALL"] = "CALL";
    /** Requires a code sent by email. */
    FactorType["EMAIL"] = "EMAIL";
    /** Requires authentication via an authenticator app. */
    FactorType["TOTP"] = "TOTP";
    /** Requires authentication via a push notification. */
    FactorType["PUSH"] = "PUSH";
    /** Requires authentication via WebAuthn/passkey. */
    FactorType["WEBAUTHN"] = "WEBAUTHN";
    /** Requires a recovery code. */
    FactorType["RECOVERY_CODE"] = "RECOVERY_CODE";
})(FactorType || (FactorType = {}));
export var MonitoringType;
(function (MonitoringType) {
    MonitoringType["UNKNOWN_PROVIDER"] = "UNKNOWN_PROVIDER";
    MonitoringType["SENTRY"] = "SENTRY";
    MonitoringType["PANORAMA"] = "PANORAMA";
})(MonitoringType || (MonitoringType = {}));
export var Escalation;
(function (Escalation) {
    Escalation["BREAK_BUILD"] = "BREAK_BUILD";
    Escalation["BLOCK_ROLLOUT"] = "BLOCK_ROLLOUT";
    Escalation["BLOCK_FUTURE_ROLLOUT"] = "BLOCK_FUTURE_ROLLOUT";
    Escalation["OPEN_BUG_SLA"] = "OPEN_BUG_SLA";
    /** only shows violation in papi-dashboard */
    Escalation["VISIBILITY"] = "VISIBILITY";
})(Escalation || (Escalation = {}));
export var ImportanceLevel;
(function (ImportanceLevel) {
    ImportanceLevel["LOW"] = "LOW";
    ImportanceLevel["MEDIUM"] = "MEDIUM";
    ImportanceLevel["HIGH"] = "HIGH";
})(ImportanceLevel || (ImportanceLevel = {}));
export var PanelSizeWidth;
(function (PanelSizeWidth) {
    PanelSizeWidth["UNKNOWN_WIDTH"] = "UNKNOWN_WIDTH";
    PanelSizeWidth["SMALL"] = "SMALL";
    PanelSizeWidth["MEDIUM"] = "MEDIUM";
    PanelSizeWidth["LARGE"] = "LARGE";
})(PanelSizeWidth || (PanelSizeWidth = {}));
/** Represents the options for panel content types */
export var PanelContentType;
(function (PanelContentType) {
    PanelContentType["UNKNOWN_PanelContentType"] = "UNKNOWN_PanelContentType";
    PanelContentType["url"] = "url";
    PanelContentType["code"] = "code";
})(PanelContentType || (PanelContentType = {}));
/** The type of storage we are declaring */
export var StorageType;
(function (StorageType) {
    StorageType["UNKNOWN_STORAGE_TYPE"] = "UNKNOWN_STORAGE_TYPE";
    /** A [cookie](https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie) we store in the browser */
    StorageType["COOKIE"] = "COOKIE";
    /** A [localStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage) item that persists across tabs in the domain */
    StorageType["LOCALSTORAGE"] = "LOCALSTORAGE";
    /** A [sessionStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage) item for a specific tab in the domain */
    StorageType["SESSIONSTORAGE"] = "SESSIONSTORAGE";
    /** An item in [IndexDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API) */
    StorageType["INDEXDB"] = "INDEXDB";
})(StorageType || (StorageType = {}));
/** The category for EU and US Privacy Law classification */
export var ConsentCategory;
(function (ConsentCategory) {
    /** This is an invalid value, you must classify your storage item. */
    ConsentCategory["UNKNOWN_CATEGORY"] = "UNKNOWN_CATEGORY";
    /** Is required for your app to function and does not use the data to do any tracking. */
    ConsentCategory["essential"] = "essential";
    /** Related to performanc and functional additions that are niceities but the app can work without. */
    ConsentCategory["functional"] = "functional";
    /** Related to analytics and may including tracking sessions and vistors to the site. */
    ConsentCategory["analytics"] = "analytics";
    /** Related to advertising, upselling and marketing data collected to be used. */
    ConsentCategory["advertising"] = "advertising";
})(ConsentCategory || (ConsentCategory = {}));
export var StorageDomain;
(function (StorageDomain) {
    StorageDomain["UNKNOWN_STORAGE_DOMAIN"] = "UNKNOWN_STORAGE_DOMAIN";
    /** Storing the values in the domain of the website the app is installed on */
    StorageDomain["SITE_DOMAIN"] = "SITE_DOMAIN";
    /** Storing the values in the Wix Backoffice domain */
    StorageDomain["WIX_DOMAIN"] = "WIX_DOMAIN";
    /** Storing the values as 3rd party in the application domain */
    StorageDomain["APP_DOMAIN"] = "APP_DOMAIN";
})(StorageDomain || (StorageDomain = {}));
export var Method;
(function (Method) {
    /** Validate an event before creation. */
    Method["CREATE"] = "CREATE";
    /** Validate an event before update. */
    Method["UPDATE"] = "UPDATE";
    /** Validate an event before cancel. */
    Method["CANCEL"] = "CANCEL";
})(Method || (Method = {}));
export var ParticipantType;
(function (ParticipantType) {
    ParticipantType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ParticipantType["WIX_USER"] = "WIX_USER";
    ParticipantType["CONTACT"] = "CONTACT";
    ParticipantType["ANONYMOUS"] = "ANONYMOUS";
})(ParticipantType || (ParticipantType = {}));
export var InterfaceConfigurationType;
(function (InterfaceConfigurationType) {
    InterfaceConfigurationType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** Widget component built by the provider */
    InterfaceConfigurationType["WIDGET_COMPONENT"] = "WIDGET_COMPONENT";
    /** Item Selection, in case the provider implemented item selection component */
    InterfaceConfigurationType["ITEM_SELECTION"] = "ITEM_SELECTION";
})(InterfaceConfigurationType || (InterfaceConfigurationType = {}));
export var Scope;
(function (Scope) {
    Scope["UNKNOWN_SCOPE"] = "UNKNOWN_SCOPE";
    /** Provider audience is available only in scope of specific site */
    Scope["SPECIFIC_SITE"] = "SPECIFIC_SITE";
    /** Provider audience is available only in scope of non specific site */
    Scope["NON_SPECIFIC_SITE"] = "NON_SPECIFIC_SITE";
})(Scope || (Scope = {}));
/** The supported [CSS Property Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) in Javascript naming format */
export var CssPropertyType;
(function (CssPropertyType) {
    CssPropertyType["UNKNOWN_CssPropertyType"] = "UNKNOWN_CssPropertyType";
    /** background properties */
    CssPropertyType["background"] = "background";
    CssPropertyType["backgroundSize"] = "backgroundSize";
    CssPropertyType["backgroundColor"] = "backgroundColor";
    CssPropertyType["backgroundImage"] = "backgroundImage";
    CssPropertyType["backgroundClip"] = "backgroundClip";
    CssPropertyType["backgroundOrigin"] = "backgroundOrigin";
    CssPropertyType["backgroundPosition"] = "backgroundPosition";
    CssPropertyType["backgroundRepeat"] = "backgroundRepeat";
    CssPropertyType["backgroundAttachment"] = "backgroundAttachment";
    CssPropertyType["fill"] = "fill";
    CssPropertyType["fillOpacity"] = "fillOpacity";
    /** margin properties */
    CssPropertyType["margin"] = "margin";
    CssPropertyType["marginTop"] = "marginTop";
    CssPropertyType["marginRight"] = "marginRight";
    CssPropertyType["marginBottom"] = "marginBottom";
    CssPropertyType["marginLeft"] = "marginLeft";
    CssPropertyType["marginInlineStart"] = "marginInlineStart";
    CssPropertyType["marginInlineEnd"] = "marginInlineEnd";
    /** padding properties */
    CssPropertyType["padding"] = "padding";
    CssPropertyType["paddingTop"] = "paddingTop";
    CssPropertyType["paddingRight"] = "paddingRight";
    CssPropertyType["paddingBottom"] = "paddingBottom";
    CssPropertyType["paddingLeft"] = "paddingLeft";
    CssPropertyType["paddingInlineStart"] = "paddingInlineStart";
    CssPropertyType["paddingInlineEnd"] = "paddingInlineEnd";
    /** border properties */
    CssPropertyType["border"] = "border";
    CssPropertyType["borderWidth"] = "borderWidth";
    CssPropertyType["borderStyle"] = "borderStyle";
    CssPropertyType["borderColor"] = "borderColor";
    CssPropertyType["borderTop"] = "borderTop";
    CssPropertyType["borderTopColor"] = "borderTopColor";
    CssPropertyType["borderTopWidth"] = "borderTopWidth";
    CssPropertyType["borderTopStyle"] = "borderTopStyle";
    CssPropertyType["borderRight"] = "borderRight";
    CssPropertyType["borderRightColor"] = "borderRightColor";
    CssPropertyType["borderRightWidth"] = "borderRightWidth";
    CssPropertyType["borderRightStyle"] = "borderRightStyle";
    CssPropertyType["borderBottom"] = "borderBottom";
    CssPropertyType["borderBottomColor"] = "borderBottomColor";
    CssPropertyType["borderBottomWidth"] = "borderBottomWidth";
    CssPropertyType["borderBottomStyle"] = "borderBottomStyle";
    CssPropertyType["borderLeft"] = "borderLeft";
    CssPropertyType["borderLeftColor"] = "borderLeftColor";
    CssPropertyType["borderLeftWidth"] = "borderLeftWidth";
    CssPropertyType["borderLeftStyle"] = "borderLeftStyle";
    CssPropertyType["borderInlineStart"] = "borderInlineStart";
    CssPropertyType["borderInlineStartColor"] = "borderInlineStartColor";
    CssPropertyType["borderInlineStartWidth"] = "borderInlineStartWidth";
    CssPropertyType["borderInlineStartStyle"] = "borderInlineStartStyle";
    CssPropertyType["borderInlineEnd"] = "borderInlineEnd";
    CssPropertyType["borderInlineEndColor"] = "borderInlineEndColor";
    CssPropertyType["borderInlineEndWidth"] = "borderInlineEndWidth";
    CssPropertyType["borderInlineEndStyle"] = "borderInlineEndStyle";
    CssPropertyType["borderRadius"] = "borderRadius";
    CssPropertyType["borderTopLeftRadius"] = "borderTopLeftRadius";
    CssPropertyType["borderTopRightRadius"] = "borderTopRightRadius";
    CssPropertyType["borderBottomRightRadius"] = "borderBottomRightRadius";
    CssPropertyType["borderBottomLeftRadius"] = "borderBottomLeftRadius";
    CssPropertyType["borderStartStartRadius"] = "borderStartStartRadius";
    CssPropertyType["borderStartEndRadius"] = "borderStartEndRadius";
    CssPropertyType["borderEndStartRadius"] = "borderEndStartRadius";
    CssPropertyType["borderEndEndRadius"] = "borderEndEndRadius";
    /** text properties */
    CssPropertyType["font"] = "font";
    CssPropertyType["fontFamily"] = "fontFamily";
    CssPropertyType["fontSize"] = "fontSize";
    CssPropertyType["fontStretch"] = "fontStretch";
    CssPropertyType["fontStyle"] = "fontStyle";
    CssPropertyType["fontVariant"] = "fontVariant";
    CssPropertyType["fontWeight"] = "fontWeight";
    CssPropertyType["lineHeight"] = "lineHeight";
    CssPropertyType["color"] = "color";
    CssPropertyType["letterSpacing"] = "letterSpacing";
    CssPropertyType["writingMode"] = "writingMode";
    CssPropertyType["textAlign"] = "textAlign";
    CssPropertyType["textTransform"] = "textTransform";
    CssPropertyType["textShadow"] = "textShadow";
    CssPropertyType["textOverflow"] = "textOverflow";
    CssPropertyType["textIndent"] = "textIndent";
    CssPropertyType["textDecoration"] = "textDecoration";
    CssPropertyType["textDecorationColor"] = "textDecorationColor";
    CssPropertyType["textDecorationLine"] = "textDecorationLine";
    CssPropertyType["textDecorationStyle"] = "textDecorationStyle";
    CssPropertyType["textDecorationThickness"] = "textDecorationThickness";
    /** general box properties */
    CssPropertyType["boxShadow"] = "boxShadow";
    CssPropertyType["opacity"] = "opacity";
    CssPropertyType["overflow"] = "overflow";
    /** layout properties */
    CssPropertyType["display"] = "display";
    CssPropertyType["alignSelf"] = "alignSelf";
    CssPropertyType["justifyContent"] = "justifyContent";
    CssPropertyType["alignItems"] = "alignItems";
    CssPropertyType["flexDirection"] = "flexDirection";
    CssPropertyType["gap"] = "gap";
    CssPropertyType["height"] = "height";
    CssPropertyType["width"] = "width";
    CssPropertyType["columnGap"] = "columnGap";
    CssPropertyType["rowGap"] = "rowGap";
    /** filters */
    CssPropertyType["filter"] = "filter";
    CssPropertyType["backdropFilter"] = "backdropFilter";
    /** media sizing & alignment */
    CssPropertyType["objectFit"] = "objectFit";
    CssPropertyType["objectPosition"] = "objectPosition";
    /** blending & compositing */
    CssPropertyType["mixBlendMode"] = "mixBlendMode";
    CssPropertyType["isolation"] = "isolation";
    /** stroke properties */
    CssPropertyType["stroke"] = "stroke";
    CssPropertyType["strokeWidth"] = "strokeWidth";
    CssPropertyType["strokeOpacity"] = "strokeOpacity";
})(CssPropertyType || (CssPropertyType = {}));
/** The supported [CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Types) in Javascript naming format */
export var CssDataType;
(function (CssDataType) {
    CssDataType["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
    CssDataType["number"] = "number";
    CssDataType["length"] = "length";
    CssDataType["color"] = "color";
    CssDataType["angle"] = "angle";
    CssDataType["percentage"] = "percentage";
    CssDataType["lengthPercentage"] = "lengthPercentage";
    CssDataType["blendMode"] = "blendMode";
    CssDataType["customEnum"] = "customEnum";
    CssDataType["string"] = "string";
    CssDataType["time"] = "time";
})(CssDataType || (CssDataType = {}));
/** The supported [CSS Property Types & CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) in Javascript naming format */
export var StyleType;
(function (StyleType) {
    StyleType["UNKNOWN_StyleType"] = "UNKNOWN_StyleType";
    /** css-data-types */
    StyleType["number"] = "number";
    StyleType["string"] = "string";
    StyleType["angle"] = "angle";
    StyleType["length"] = "length";
    StyleType["percentage"] = "percentage";
    StyleType["lengthPercentage"] = "lengthPercentage";
    StyleType["blendMode"] = "blendMode";
    StyleType["customEnum"] = "customEnum";
    StyleType["time"] = "time";
    /** background properties */
    StyleType["background"] = "background";
    StyleType["backgroundSize"] = "backgroundSize";
    StyleType["backgroundColor"] = "backgroundColor";
    StyleType["backgroundImage"] = "backgroundImage";
    StyleType["backgroundClip"] = "backgroundClip";
    StyleType["backgroundOrigin"] = "backgroundOrigin";
    StyleType["backgroundPosition"] = "backgroundPosition";
    StyleType["backgroundRepeat"] = "backgroundRepeat";
    StyleType["backgroundAttachment"] = "backgroundAttachment";
    /** margin properties */
    StyleType["margin"] = "margin";
    StyleType["marginTop"] = "marginTop";
    StyleType["marginRight"] = "marginRight";
    StyleType["marginBottom"] = "marginBottom";
    StyleType["marginLeft"] = "marginLeft";
    StyleType["marginInlineStart"] = "marginInlineStart";
    StyleType["marginInlineEnd"] = "marginInlineEnd";
    /** padding properties */
    StyleType["padding"] = "padding";
    StyleType["paddingTop"] = "paddingTop";
    StyleType["paddingRight"] = "paddingRight";
    StyleType["paddingBottom"] = "paddingBottom";
    StyleType["paddingLeft"] = "paddingLeft";
    StyleType["paddingInlineStart"] = "paddingInlineStart";
    StyleType["paddingInlineEnd"] = "paddingInlineEnd";
    /** border properties */
    StyleType["border"] = "border";
    StyleType["borderWidth"] = "borderWidth";
    StyleType["borderStyle"] = "borderStyle";
    StyleType["borderColor"] = "borderColor";
    StyleType["borderTop"] = "borderTop";
    StyleType["borderTopColor"] = "borderTopColor";
    StyleType["borderTopWidth"] = "borderTopWidth";
    StyleType["borderTopStyle"] = "borderTopStyle";
    StyleType["borderRight"] = "borderRight";
    StyleType["borderRightColor"] = "borderRightColor";
    StyleType["borderRightWidth"] = "borderRightWidth";
    StyleType["borderRightStyle"] = "borderRightStyle";
    StyleType["borderBottom"] = "borderBottom";
    StyleType["borderBottomColor"] = "borderBottomColor";
    StyleType["borderBottomWidth"] = "borderBottomWidth";
    StyleType["borderBottomStyle"] = "borderBottomStyle";
    StyleType["borderLeft"] = "borderLeft";
    StyleType["borderLeftColor"] = "borderLeftColor";
    StyleType["borderLeftWidth"] = "borderLeftWidth";
    StyleType["borderLeftStyle"] = "borderLeftStyle";
    StyleType["borderInlineStart"] = "borderInlineStart";
    StyleType["borderInlineStartColor"] = "borderInlineStartColor";
    StyleType["borderInlineStartWidth"] = "borderInlineStartWidth";
    StyleType["borderInlineStartStyle"] = "borderInlineStartStyle";
    StyleType["borderInlineEnd"] = "borderInlineEnd";
    StyleType["borderInlineEndColor"] = "borderInlineEndColor";
    StyleType["borderInlineEndWidth"] = "borderInlineEndWidth";
    StyleType["borderInlineEndStyle"] = "borderInlineEndStyle";
    /** border-radius properties */
    StyleType["borderRadius"] = "borderRadius";
    StyleType["borderTopLeftRadius"] = "borderTopLeftRadius";
    StyleType["borderTopRightRadius"] = "borderTopRightRadius";
    StyleType["borderBottomRightRadius"] = "borderBottomRightRadius";
    StyleType["borderBottomLeftRadius"] = "borderBottomLeftRadius";
    StyleType["borderStartStartRadius"] = "borderStartStartRadius";
    StyleType["borderStartEndRadius"] = "borderStartEndRadius";
    StyleType["borderEndStartRadius"] = "borderEndStartRadius";
    StyleType["borderEndEndRadius"] = "borderEndEndRadius";
    /** font properties */
    StyleType["font"] = "font";
    StyleType["fontFamily"] = "fontFamily";
    StyleType["fontSize"] = "fontSize";
    StyleType["fontStretch"] = "fontStretch";
    StyleType["fontStyle"] = "fontStyle";
    StyleType["fontVariant"] = "fontVariant";
    StyleType["fontWeight"] = "fontWeight";
    StyleType["lineHeight"] = "lineHeight";
    /** text properties */
    StyleType["color"] = "color";
    StyleType["letterSpacing"] = "letterSpacing";
    StyleType["writingMode"] = "writingMode";
    StyleType["textAlign"] = "textAlign";
    StyleType["textTransform"] = "textTransform";
    StyleType["textShadow"] = "textShadow";
    StyleType["textOverflow"] = "textOverflow";
    StyleType["textIndent"] = "textIndent";
    /** text-decoration properties */
    StyleType["textDecoration"] = "textDecoration";
    StyleType["textDecorationColor"] = "textDecorationColor";
    StyleType["textDecorationLine"] = "textDecorationLine";
    StyleType["textDecorationStyle"] = "textDecorationStyle";
    StyleType["textDecorationThickness"] = "textDecorationThickness";
    /** box related properties */
    StyleType["boxShadow"] = "boxShadow";
    StyleType["opacity"] = "opacity";
    StyleType["overflow"] = "overflow";
    /** layout properties */
    StyleType["display"] = "display";
    StyleType["alignSelf"] = "alignSelf";
    StyleType["justifyContent"] = "justifyContent";
    StyleType["alignItems"] = "alignItems";
    StyleType["flexDirection"] = "flexDirection";
    StyleType["height"] = "height";
    StyleType["width"] = "width";
    StyleType["gap"] = "gap";
    StyleType["columnGap"] = "columnGap";
    StyleType["rowGap"] = "rowGap";
    /** filters */
    StyleType["filter"] = "filter";
    StyleType["backdropFilter"] = "backdropFilter";
    /** media sizing & alignment */
    StyleType["objectFit"] = "objectFit";
    StyleType["objectPosition"] = "objectPosition";
    /** blending & compositing */
    StyleType["mixBlendMode"] = "mixBlendMode";
    StyleType["isolation"] = "isolation";
    /** stroke properties */
    StyleType["stroke"] = "stroke";
    StyleType["strokeWidth"] = "strokeWidth";
    StyleType["strokeOpacity"] = "strokeOpacity";
    /** fill properties */
    StyleType["fill"] = "fill";
    StyleType["fillOpacity"] = "fillOpacity";
})(StyleType || (StyleType = {}));
export var FilterFunction;
(function (FilterFunction) {
    FilterFunction["UNKNOWN_FilterFunctions"] = "UNKNOWN_FilterFunctions";
    /** The value used for blur filter */
    FilterFunction["blur"] = "blur";
    /** The value used for brightness filter */
    FilterFunction["brightness"] = "brightness";
    /** The value used for contrast filter */
    FilterFunction["contrast"] = "contrast";
    /** The value used for drop-shadow filter */
    FilterFunction["drop_shadow"] = "drop_shadow";
    /** The value used for grayscale filter */
    FilterFunction["grayscale"] = "grayscale";
    /** The value used for hue-rotate filter */
    FilterFunction["hue_rotate"] = "hue_rotate";
    /** The value used for invert filter */
    FilterFunction["invert"] = "invert";
    /** The value used for opacity filter */
    FilterFunction["opacity"] = "opacity";
    /** The value used for sepia filter */
    FilterFunction["sepia"] = "sepia";
    /** The value used for saturate filter */
    FilterFunction["saturate"] = "saturate";
})(FilterFunction || (FilterFunction = {}));
export var DisplayValueEnumDisplayValue;
(function (DisplayValueEnumDisplayValue) {
    DisplayValueEnumDisplayValue["UNKNOWN_DisplayValue"] = "UNKNOWN_DisplayValue";
    DisplayValueEnumDisplayValue["none"] = "none";
    DisplayValueEnumDisplayValue["block"] = "block";
    DisplayValueEnumDisplayValue["inline"] = "inline";
    DisplayValueEnumDisplayValue["flow"] = "flow";
    DisplayValueEnumDisplayValue["flowRoot"] = "flowRoot";
    DisplayValueEnumDisplayValue["table"] = "table";
    DisplayValueEnumDisplayValue["flex"] = "flex";
    DisplayValueEnumDisplayValue["grid"] = "grid";
    DisplayValueEnumDisplayValue["list_item"] = "list_item";
    DisplayValueEnumDisplayValue["contents"] = "contents";
    DisplayValueEnumDisplayValue["inline_block"] = "inline_block";
    DisplayValueEnumDisplayValue["inline_table"] = "inline_table";
    DisplayValueEnumDisplayValue["inline_flex"] = "inline_flex";
    DisplayValueEnumDisplayValue["inline_grid"] = "inline_grid";
})(DisplayValueEnumDisplayValue || (DisplayValueEnumDisplayValue = {}));
export var WritingModeValue;
(function (WritingModeValue) {
    WritingModeValue["UNKNOWN_WritingModeValue"] = "UNKNOWN_WritingModeValue";
    WritingModeValue["horizontalTb"] = "horizontalTb";
    WritingModeValue["verticalRl"] = "verticalRl";
    WritingModeValue["verticalLr"] = "verticalLr";
    WritingModeValue["sidewaysRl"] = "sidewaysRl";
    WritingModeValue["sidewaysLr"] = "sidewaysLr";
})(WritingModeValue || (WritingModeValue = {}));
export var BackgroundModeEnum;
(function (BackgroundModeEnum) {
    BackgroundModeEnum["UNKNOWN_BackgroundModeEnum"] = "UNKNOWN_BackgroundModeEnum";
    BackgroundModeEnum["shapeDividerSvg"] = "shapeDividerSvg";
})(BackgroundModeEnum || (BackgroundModeEnum = {}));
/** Categories to open media manager filtered by the component needs */
export var ImageCategoryTypes;
(function (ImageCategoryTypes) {
    /** Default value when image category is not specified */
    ImageCategoryTypes["UNKNOWN_CategoryName"] = "UNKNOWN_CategoryName";
    /** Images - mapped to IMAGE */
    ImageCategoryTypes["IMAGE"] = "IMAGE";
    /** Background Images - mapped to BG_IMAGE */
    ImageCategoryTypes["IMAGE_BACKGROUND"] = "IMAGE_BACKGROUND";
})(ImageCategoryTypes || (ImageCategoryTypes = {}));
export var VectorArtCategoryTypes;
(function (VectorArtCategoryTypes) {
    /** Default value when vector art category is not specified */
    VectorArtCategoryTypes["UNKNOWN_VectorArtCategoryTypes"] = "UNKNOWN_VectorArtCategoryTypes";
    /** Vector Art (both basic and art shapes) - mapped to VECTOR_ART */
    VectorArtCategoryTypes["SHAPE_ALL"] = "SHAPE_ALL";
    /** Basic Shapes - mapped to SHAPE_BASIC */
    VectorArtCategoryTypes["SHAPE_BASIC"] = "SHAPE_BASIC";
    /** Vector Art Shapes - mapped to SHAPE_ART */
    VectorArtCategoryTypes["SHAPE_ART"] = "SHAPE_ART";
    /** Social Icons - mapped to ICON_SOCIAL */
    VectorArtCategoryTypes["ICON_SOCIAL"] = "ICON_SOCIAL";
    /** SVG Shape Dividers - mapped to DIVIDERS */
    VectorArtCategoryTypes["SHAPE_DIVIDERS"] = "SHAPE_DIVIDERS";
})(VectorArtCategoryTypes || (VectorArtCategoryTypes = {}));
export var CssDataTypeEnumCssDataType;
(function (CssDataTypeEnumCssDataType) {
    CssDataTypeEnumCssDataType["UNKNOWN_CssDataType"] = "UNKNOWN_CssDataType";
    CssDataTypeEnumCssDataType["number"] = "number";
    CssDataTypeEnumCssDataType["string"] = "string";
    CssDataTypeEnumCssDataType["angle"] = "angle";
    CssDataTypeEnumCssDataType["color"] = "color";
    CssDataTypeEnumCssDataType["length"] = "length";
    CssDataTypeEnumCssDataType["percentage"] = "percentage";
    CssDataTypeEnumCssDataType["lengthPercentage"] = "lengthPercentage";
    CssDataTypeEnumCssDataType["blendMode"] = "blendMode";
    CssDataTypeEnumCssDataType["customEnum"] = "customEnum";
    CssDataTypeEnumCssDataType["time"] = "time";
})(CssDataTypeEnumCssDataType || (CssDataTypeEnumCssDataType = {}));
export var DataType;
(function (DataType) {
    DataType["UNKNOWN_DataType"] = "UNKNOWN_DataType";
    /** A simple text value */
    DataType["text"] = "text";
    /** A list of predefined textual values to choose from */
    DataType["textEnum"] = "textEnum";
    /** Any number */
    DataType["number"] = "number";
    /** true / false value */
    DataType["booleanValue"] = "booleanValue";
    /** An object containing the selected A11Y fields chosen */
    DataType["a11y"] = "a11y";
    /** A Wix Link object type */
    DataType["link"] = "link";
    /** A Wix Image object type */
    DataType["image"] = "image";
    /** A Wix Video object type */
    DataType["video"] = "video";
    /** A Wix Sanitized Vector Art object */
    DataType["vectorArt"] = "vectorArt";
    /** A Wix Audio object */
    DataType["audio"] = "audio";
    /** A [JSON Schema definition](https://json-schema.org/specification) the developer understands in his code (useful for complex props). Some limitation may apply. */
    DataType["schema"] = "schema";
    /** Local date output ISO-8601 extended local date format (YYYY-MM-DD) */
    DataType["localDate"] = "localDate";
    /** Local time output ISO-8601 extended local time format (hh:mm[:ss][.sss]) */
    DataType["localTime"] = "localTime";
    /** Local Date Time output  ISO-8601 extended local date-time format (YYYY-MM-DDThh:mm[:ss][.sss]) */
    DataType["localDateTime"] = "localDateTime";
    /** a URL with scheme http or https */
    DataType["webUrl"] = "webUrl";
    /** standard email address according to [RFC 5321, section 4.1.2](https://datatracker.ietf.org/doc/html/rfc5321#section-4.1.2) */
    DataType["email"] = "email";
    /** a validation format designed to match phone numbers with a variety of common characters, including digits (0-9), spaces, parentheses, plus sign, hyphens, and periods */
    DataType["phone"] = "phone";
    /** hostname according to IANA */
    DataType["hostname"] = "hostname";
    /** A valid `regex` pattern supplied by the User */
    DataType["regex"] = "regex";
    /** A unique identifier */
    DataType["guid"] = "guid";
    /** a HTML text with css inline styling */
    DataType["richText"] = "richText";
    /** A container place in the component that will be passed in as {children} or a function prop, depending on the case */
    DataType["container"] = "container";
    /** An array type of data */
    DataType["arrayItems"] = "arrayItems";
    /** selected `direction` for the component according to (HTML `dir` attribute)[https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/dir] */
    DataType["direction"] = "direction";
    /** A list of menu-items */
    DataType["menuItems"] = "menuItems";
})(DataType || (DataType = {}));
export var A11yAttributes;
(function (A11yAttributes) {
    A11yAttributes["Unknown_AriaAttributes"] = "Unknown_AriaAttributes";
    /** The value used for tabIndex attribute */
    A11yAttributes["tabIndex"] = "tabIndex";
    /** The value used for aria-level */
    A11yAttributes["ariaLevel"] = "ariaLevel";
    /** The value used for aria-expanded */
    A11yAttributes["ariaExpanded"] = "ariaExpanded";
    /** The value used for aria-disabled */
    A11yAttributes["ariaDisabled"] = "ariaDisabled";
    /** The value used for aria-atomic */
    A11yAttributes["ariaAtomic"] = "ariaAtomic";
    /** The value used for aria-hidden */
    A11yAttributes["ariaHidden"] = "ariaHidden";
    /** The value used for aria-busy */
    A11yAttributes["ariaBusy"] = "ariaBusy";
    /** Indicates if should add Multiline instructions to aria-label */
    A11yAttributes["multiline"] = "multiline";
    /** Indicates if should add Autocomplete instructions to aria-label */
    A11yAttributes["ariaAutocomplete"] = "ariaAutocomplete";
    /** The value used for aria-pressed */
    A11yAttributes["ariaPressed"] = "ariaPressed";
    /** The value used for aria-haspopup */
    A11yAttributes["ariaHaspopup"] = "ariaHaspopup";
    /** The value used for aria-relevant */
    A11yAttributes["ariaRelevant"] = "ariaRelevant";
    /** The value used for role attribute */
    A11yAttributes["role"] = "role";
    /** The value used for aria-live */
    A11yAttributes["ariaLive"] = "ariaLive";
    /** The value used for aria-current */
    A11yAttributes["ariaCurrent"] = "ariaCurrent";
    /** The text used for aria-label */
    A11yAttributes["ariaLabel"] = "ariaLabel";
    /** The text used for aria-roledescription */
    A11yAttributes["ariaRoledescription"] = "ariaRoledescription";
    /** The value used for aria-describedby */
    A11yAttributes["ariaDescribedby"] = "ariaDescribedby";
    /** The value used for aria-labelledby */
    A11yAttributes["ariaLabelledby"] = "ariaLabelledby";
    /** The text used for aria-errormessage */
    A11yAttributes["ariaErrormessage"] = "ariaErrormessage";
    /** The text used for aria-owns */
    A11yAttributes["ariaOwns"] = "ariaOwns";
    /** The text used for aria-controls */
    A11yAttributes["ariaControls"] = "ariaControls";
    /** The HTML tag to use for the element */
    A11yAttributes["tag"] = "tag";
    /** The value used for aria-multiline */
    A11yAttributes["ariaMultiline"] = "ariaMultiline";
    /** The value used for aria-invalid */
    A11yAttributes["ariaInvalid"] = "ariaInvalid";
})(A11yAttributes || (A11yAttributes = {}));
export var LinkType;
(function (LinkType) {
    LinkType["UNKNOWN_LinkType"] = "UNKNOWN_LinkType";
    /** A link to another website */
    LinkType["externalLink"] = "externalLink";
    /** A link to an item on the current page */
    LinkType["anchorLink"] = "anchorLink";
    /** A valid email link (`mailto:example@example.com`) */
    LinkType["emailLink"] = "emailLink";
    /** A valid phone link (`phone:11111111111`) */
    LinkType["phoneLink"] = "phoneLink";
    /** A link to a page in Wix that needs to be selected dynamically */
    LinkType["dynamicPageLink"] = "dynamicPageLink";
    /** A link to another page on the site */
    LinkType["pageLink"] = "pageLink";
    /** A link to open a whatsapp conversation */
    LinkType["whatsAppLink"] = "whatsAppLink";
    /** A link to a PDF file hosted by Wix */
    LinkType["documentLink"] = "documentLink";
    /** A link that opens a lightbox */
    LinkType["popupLink"] = "popupLink";
    /** A link that directs the user to an address on google maps */
    LinkType["addressLink"] = "addressLink";
    /** A link that scrolls to the top/bottom of the page */
    LinkType["edgeAnchorLinks"] = "edgeAnchorLinks";
    /** A link that directs the user to wix login dialog */
    LinkType["loginToWixLink"] = "loginToWixLink";
})(LinkType || (LinkType = {}));
export var ContainerType;
(function (ContainerType) {
    /** An undefined container type, is invalid */
    ContainerType["UNKNOWN_CONTAINER_TYPE"] = "UNKNOWN_CONTAINER_TYPE";
    /** A simple container that can support adding and layouting elements in the editor */
    ContainerType["simple"] = "simple";
    /** A slot declared by a component in DEV Center that allows integrations with a Props API from the host */
    ContainerType["slot"] = "slot";
    /** A container to add elements targeting a specific product use case, exposed in DEV Center */
    ContainerType["placeholder"] = "placeholder";
    /** A container that can be used to render a template multiple times */
    ContainerType["template"] = "template";
})(ContainerType || (ContainerType = {}));
export var ResizeDirection;
(function (ResizeDirection) {
    /** Default value when direction is not specified */
    ResizeDirection["UNKNOWN_ResizeDirection"] = "UNKNOWN_ResizeDirection";
    /** Component can only be resized horizontally */
    ResizeDirection["horizontal"] = "horizontal";
    /** Component can only be resized vertically */
    ResizeDirection["vertical"] = "vertical";
    /** Component can be resized both horizontally and vertically */
    ResizeDirection["horizontalAndVertical"] = "horizontalAndVertical";
    /** Component maintains its aspect ratio while resizing */
    ResizeDirection["aspectRatio"] = "aspectRatio";
    /** Component cannot be resized in any direction */
    ResizeDirection["none"] = "none";
})(ResizeDirection || (ResizeDirection = {}));
export var RichTextAbilities;
(function (RichTextAbilities) {
    RichTextAbilities["UNKNOWN_RichTextAbilities"] = "UNKNOWN_RichTextAbilities";
    /** selected theme font, also changing the html tag */
    RichTextAbilities["font"] = "font";
    /** font family of the text */
    RichTextAbilities["fontFamily"] = "fontFamily";
    /** font size of the text */
    RichTextAbilities["fontSize"] = "fontSize";
    /** italic / normal */
    RichTextAbilities["fontStyle"] = "fontStyle";
    /** bold / normal / 100-900 */
    RichTextAbilities["fontWeight"] = "fontWeight";
    /** underline / line-through */
    RichTextAbilities["textDecoration"] = "textDecoration";
    /** color of the text */
    RichTextAbilities["color"] = "color";
    /** background color of the text */
    RichTextAbilities["backgroundColor"] = "backgroundColor";
    /** letter spacing of the text */
    RichTextAbilities["letterSpacing"] = "letterSpacing";
    /** left / center / right / justify */
    RichTextAbilities["textAlign"] = "textAlign";
    /** rtl/ltr */
    RichTextAbilities["direction"] = "direction";
    /** indent of the text */
    RichTextAbilities["marginStart"] = "marginStart";
    /** outdent of the text */
    RichTextAbilities["marginEnd"] = "marginEnd";
    /** special data: */
    RichTextAbilities["bulletedList"] = "bulletedList";
    /** implemented with <ol> */
    RichTextAbilities["numberedList"] = "numberedList";
    /** h1,h2,h3,h4,h5,h6,p,blockquote */
    RichTextAbilities["seoTag"] = "seoTag";
})(RichTextAbilities || (RichTextAbilities = {}));
export var VideoCategoryTypes;
(function (VideoCategoryTypes) {
    /** Default value when video category is not specified */
    VideoCategoryTypes["UNKNOWN_VideoCategoryTypes"] = "UNKNOWN_VideoCategoryTypes";
    /** Both videos and transparent videos - mapped to VIDEO_BOX */
    VideoCategoryTypes["VIDEO"] = "VIDEO";
    /** Transparent videos - mapped to VIDEO_ALPHA */
    VideoCategoryTypes["VIDEO_TRANSPARENT"] = "VIDEO_TRANSPARENT";
    /** Videos without transparency - mapped to VIDEO */
    VideoCategoryTypes["VIDEO_OPAQUE"] = "VIDEO_OPAQUE";
})(VideoCategoryTypes || (VideoCategoryTypes = {}));
export var ElementTypeEnumElementType;
(function (ElementTypeEnumElementType) {
    ElementTypeEnumElementType["UNKNOWN_ElementType"] = "UNKNOWN_ElementType";
    /** An element that was written as part of the component */
    ElementTypeEnumElementType["inlineElement"] = "inlineElement";
    /** An element provided by the Wix ecosystem that we are reusing. These elements must exist in the Wix DEV Center. */
    ElementTypeEnumElementType["refElement"] = "refElement";
})(ElementTypeEnumElementType || (ElementTypeEnumElementType = {}));
export var ActionTypeEnumActionType;
(function (ActionTypeEnumActionType) {
    ActionTypeEnumActionType["UNKNOWN_ActionType"] = "UNKNOWN_ActionType";
    ActionTypeEnumActionType["data"] = "data";
    ActionTypeEnumActionType["event"] = "event";
    ActionTypeEnumActionType["panel"] = "panel";
    ActionTypeEnumActionType["forward"] = "forward";
    ActionTypeEnumActionType["style"] = "style";
    ActionTypeEnumActionType["displayGroup"] = "displayGroup";
    ActionTypeEnumActionType["cssProperty"] = "cssProperty";
    ActionTypeEnumActionType["cssCustomProperty"] = "cssCustomProperty";
})(ActionTypeEnumActionType || (ActionTypeEnumActionType = {}));
/** list of possible panel types */
export var PanelType;
(function (PanelType) {
    PanelType["UNKNOWN_PanelType"] = "UNKNOWN_PanelType";
    PanelType["panelId"] = "panelId";
    PanelType["inline"] = "inline";
})(PanelType || (PanelType = {}));
export var ActionName;
(function (ActionName) {
    ActionName["UNKNOWN_ActionName"] = "UNKNOWN_ActionName";
    /** Manage the component settings, this usually aligns with component data */
    ActionName["settings"] = "settings";
    /** Manage the `style` information */
    ActionName["design"] = "design";
    /** Manage any media type `data` defined in the component */
    ActionName["media"] = "media";
    /** Manage items in the component data */
    ActionName["manageItems"] = "manageItems";
    /** Open the apps default dashboard page, or select one if there is more than one */
    ActionName["dashboard"] = "dashboard";
    /** actionName to be triggered from the defined custom actions */
    ActionName["custom"] = "custom";
    /** Manage Menu Items */
    ActionName["manageMenu"] = "manageMenu";
    /** Shows the container actions, or select one if there is more than one */
    ActionName["container"] = "container";
})(ActionName || (ActionName = {}));
export var SizingType;
(function (SizingType) {
    SizingType["UNKNOWN_SizingType"] = "UNKNOWN_SizingType";
    /** Initial size should fit to the [content size](https://developer.mozilla.org/en-US/docs/Web/CSS/fit-content) */
    SizingType["content"] = "content";
    /** Initial size should stretch to the parent size and will keep tracking it unless a user changes it */
    SizingType["stretched"] = "stretched";
    /** Initial size should be set in pixels */
    SizingType["pixels"] = "pixels";
})(SizingType || (SizingType = {}));
export var BreakpointEnumBreakpoint;
(function (BreakpointEnumBreakpoint) {
    BreakpointEnumBreakpoint["UNKNOWN_Breakpoint"] = "UNKNOWN_Breakpoint";
    /** Represents the small (mobile) breakpoint */
    BreakpointEnumBreakpoint["small"] = "small";
    /** Represents the large (desktop) breakpoint */
    BreakpointEnumBreakpoint["large"] = "large";
})(BreakpointEnumBreakpoint || (BreakpointEnumBreakpoint = {}));
export var ContentResizeDirection;
(function (ContentResizeDirection) {
    /** Default value when content resize behavior is not specified */
    ContentResizeDirection["UNKNOWN_ContentResizeDirection"] = "UNKNOWN_ContentResizeDirection";
    /** Component's width will automatically adjust based on its content */
    ContentResizeDirection["horizontal"] = "horizontal";
    /** Component's height will automatically adjust based on its content */
    ContentResizeDirection["vertical"] = "vertical";
    /** Component's width and height will automatically adjust based on its content */
    ContentResizeDirection["horizontalAndVertical"] = "horizontalAndVertical";
    /** Component's size will not be affected by its content */
    ContentResizeDirection["none"] = "none";
})(ContentResizeDirection || (ContentResizeDirection = {}));
export var Archetype;
(function (Archetype) {
    Archetype["UNKNOWN_Archetype"] = "UNKNOWN_Archetype";
    Archetype["Button"] = "Button";
    Archetype["LoginButton"] = "LoginButton";
    Archetype["Image"] = "Image";
    Archetype["Gallery"] = "Gallery";
    Archetype["Video"] = "Video";
    Archetype["Audio"] = "Audio";
    Archetype["Text"] = "Text";
    Archetype["TextInput"] = "TextInput";
    Archetype["RichTextEditor"] = "RichTextEditor";
    Archetype["SignatureInput"] = "SignatureInput";
    Archetype["Checkbox"] = "Checkbox";
    Archetype["RadioGroup"] = "RadioGroup";
    Archetype["Switch"] = "Switch";
    Archetype["Dropdown"] = "Dropdown";
    Archetype["DatePicker"] = "DatePicker";
    Archetype["TimePicker"] = "TimePicker";
    Archetype["Ratings"] = "Ratings";
    Archetype["RatingInput"] = "RatingInput";
    Archetype["Menu"] = "Menu";
    Archetype["Pagination"] = "Pagination";
    Archetype["Slider"] = "Slider";
    Archetype["Container"] = "Container";
    Archetype["Carousel"] = "Carousel";
    Archetype["Accordion"] = "Accordion";
    Archetype["Tabs"] = "Tabs";
    Archetype["ProgressBar"] = "ProgressBar";
    Archetype["Upload"] = "Upload";
    Archetype["Social"] = "Social";
    Archetype["Breadcrumbs"] = "Breadcrumbs";
    Archetype["SearchBox"] = "SearchBox";
    Archetype["Map"] = "Map";
    Archetype["Line"] = "Line";
    Archetype["Logo"] = "Logo";
    Archetype["Avatar"] = "Avatar";
    Archetype["Captcha"] = "Captcha";
    Archetype["VectorArt"] = "VectorArt";
    Archetype["AnimatedGraphic"] = "AnimatedGraphic";
    Archetype["Cart"] = "Cart";
    Archetype["ContactForm"] = "ContactForm";
    Archetype["Frame"] = "Frame";
})(Archetype || (Archetype = {}));
export var NativeStateType;
(function (NativeStateType) {
    NativeStateType["UNKNOWN_NativeStateType"] = "UNKNOWN_NativeStateType";
    /** native browser "hover" state */
    NativeStateType["hover"] = "hover";
    /** native browser "focus" state */
    NativeStateType["focus"] = "focus";
    /** native browser "disabled" state */
    NativeStateType["disabled"] = "disabled";
    /** native browser "invalid" state */
    NativeStateType["invalid"] = "invalid";
})(NativeStateType || (NativeStateType = {}));
export var GroupType;
(function (GroupType) {
    GroupType["UNKNOWN_GroupType"] = "UNKNOWN_GroupType";
    GroupType["cssDataType"] = "cssDataType";
    GroupType["dataType"] = "dataType";
    GroupType["preset"] = "preset";
    /** Style Shorthand Groups */
    GroupType["background"] = "background";
    GroupType["margin"] = "margin";
    GroupType["padding"] = "padding";
    GroupType["border"] = "border";
    GroupType["borderTop"] = "borderTop";
    GroupType["borderRight"] = "borderRight";
    GroupType["borderBottom"] = "borderBottom";
    GroupType["borderLeft"] = "borderLeft";
    GroupType["borderRadius"] = "borderRadius";
    GroupType["borderInlineStart"] = "borderInlineStart";
    GroupType["borderInlineEnd"] = "borderInlineEnd";
    GroupType["font"] = "font";
    GroupType["textDecoration"] = "textDecoration";
    GroupType["gap"] = "gap";
    /** Data Groups */
    GroupType["arrayItems"] = "arrayItems";
    /** Deprecated, use `listItem` instead */
    GroupType["arrayItem"] = "arrayItem";
    GroupType["listItem"] = "listItem";
})(GroupType || (GroupType = {}));
/**
 * The supported [CSS Property Types & CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/Reference#index) and
 * [CSS Data Types](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Values_and_Units/CSS_data_types) in Javascript naming format
 */
export var CssPropertyEnumCssPropertyType;
(function (CssPropertyEnumCssPropertyType) {
    CssPropertyEnumCssPropertyType["UNKNOWN_CssPropertyType"] = "UNKNOWN_CssPropertyType";
    /** css-data-types */
    CssPropertyEnumCssPropertyType["number"] = "number";
    CssPropertyEnumCssPropertyType["string"] = "string";
    CssPropertyEnumCssPropertyType["angle"] = "angle";
    CssPropertyEnumCssPropertyType["length"] = "length";
    CssPropertyEnumCssPropertyType["percentage"] = "percentage";
    CssPropertyEnumCssPropertyType["lengthPercentage"] = "lengthPercentage";
    CssPropertyEnumCssPropertyType["blendMode"] = "blendMode";
    CssPropertyEnumCssPropertyType["customEnum"] = "customEnum";
    CssPropertyEnumCssPropertyType["time"] = "time";
    /** background properties */
    CssPropertyEnumCssPropertyType["background"] = "background";
    CssPropertyEnumCssPropertyType["backgroundSize"] = "backgroundSize";
    CssPropertyEnumCssPropertyType["backgroundColor"] = "backgroundColor";
    CssPropertyEnumCssPropertyType["backgroundImage"] = "backgroundImage";
    CssPropertyEnumCssPropertyType["backgroundClip"] = "backgroundClip";
    CssPropertyEnumCssPropertyType["backgroundOrigin"] = "backgroundOrigin";
    CssPropertyEnumCssPropertyType["backgroundPosition"] = "backgroundPosition";
    CssPropertyEnumCssPropertyType["backgroundRepeat"] = "backgroundRepeat";
    CssPropertyEnumCssPropertyType["backgroundAttachment"] = "backgroundAttachment";
    /** margin properties */
    CssPropertyEnumCssPropertyType["margin"] = "margin";
    CssPropertyEnumCssPropertyType["marginTop"] = "marginTop";
    CssPropertyEnumCssPropertyType["marginRight"] = "marginRight";
    CssPropertyEnumCssPropertyType["marginBottom"] = "marginBottom";
    CssPropertyEnumCssPropertyType["marginLeft"] = "marginLeft";
    CssPropertyEnumCssPropertyType["marginInlineStart"] = "marginInlineStart";
    CssPropertyEnumCssPropertyType["marginInlineEnd"] = "marginInlineEnd";
    /** padding properties */
    CssPropertyEnumCssPropertyType["padding"] = "padding";
    CssPropertyEnumCssPropertyType["paddingTop"] = "paddingTop";
    CssPropertyEnumCssPropertyType["paddingRight"] = "paddingRight";
    CssPropertyEnumCssPropertyType["paddingBottom"] = "paddingBottom";
    CssPropertyEnumCssPropertyType["paddingLeft"] = "paddingLeft";
    CssPropertyEnumCssPropertyType["paddingInlineStart"] = "paddingInlineStart";
    CssPropertyEnumCssPropertyType["paddingInlineEnd"] = "paddingInlineEnd";
    /** border properties */
    CssPropertyEnumCssPropertyType["border"] = "border";
    CssPropertyEnumCssPropertyType["borderWidth"] = "borderWidth";
    CssPropertyEnumCssPropertyType["borderStyle"] = "borderStyle";
    CssPropertyEnumCssPropertyType["borderColor"] = "borderColor";
    CssPropertyEnumCssPropertyType["borderTop"] = "borderTop";
    CssPropertyEnumCssPropertyType["borderTopColor"] = "borderTopColor";
    CssPropertyEnumCssPropertyType["borderTopWidth"] = "borderTopWidth";
    CssPropertyEnumCssPropertyType["borderTopStyle"] = "borderTopStyle";
    CssPropertyEnumCssPropertyType["borderRight"] = "borderRight";
    CssPropertyEnumCssPropertyType["borderRightColor"] = "borderRightColor";
    CssPropertyEnumCssPropertyType["borderRightWidth"] = "borderRightWidth";
    CssPropertyEnumCssPropertyType["borderRightStyle"] = "borderRightStyle";
    CssPropertyEnumCssPropertyType["borderBottom"] = "borderBottom";
    CssPropertyEnumCssPropertyType["borderBottomColor"] = "borderBottomColor";
    CssPropertyEnumCssPropertyType["borderBottomWidth"] = "borderBottomWidth";
    CssPropertyEnumCssPropertyType["borderBottomStyle"] = "borderBottomStyle";
    CssPropertyEnumCssPropertyType["borderLeft"] = "borderLeft";
    CssPropertyEnumCssPropertyType["borderLeftColor"] = "borderLeftColor";
    CssPropertyEnumCssPropertyType["borderLeftWidth"] = "borderLeftWidth";
    CssPropertyEnumCssPropertyType["borderLeftStyle"] = "borderLeftStyle";
    CssPropertyEnumCssPropertyType["borderInlineStart"] = "borderInlineStart";
    CssPropertyEnumCssPropertyType["borderInlineStartColor"] = "borderInlineStartColor";
    CssPropertyEnumCssPropertyType["borderInlineStartWidth"] = "borderInlineStartWidth";
    CssPropertyEnumCssPropertyType["borderInlineStartStyle"] = "borderInlineStartStyle";
    CssPropertyEnumCssPropertyType["borderInlineEnd"] = "borderInlineEnd";
    CssPropertyEnumCssPropertyType["borderInlineEndColor"] = "borderInlineEndColor";
    CssPropertyEnumCssPropertyType["borderInlineEndWidth"] = "borderInlineEndWidth";
    CssPropertyEnumCssPropertyType["borderInlineEndStyle"] = "borderInlineEndStyle";
    /** border-radius properties */
    CssPropertyEnumCssPropertyType["borderRadius"] = "borderRadius";
    CssPropertyEnumCssPropertyType["borderTopLeftRadius"] = "borderTopLeftRadius";
    CssPropertyEnumCssPropertyType["borderTopRightRadius"] = "borderTopRightRadius";
    CssPropertyEnumCssPropertyType["borderBottomRightRadius"] = "borderBottomRightRadius";
    CssPropertyEnumCssPropertyType["borderBottomLeftRadius"] = "borderBottomLeftRadius";
    CssPropertyEnumCssPropertyType["borderStartStartRadius"] = "borderStartStartRadius";
    CssPropertyEnumCssPropertyType["borderStartEndRadius"] = "borderStartEndRadius";
    CssPropertyEnumCssPropertyType["borderEndStartRadius"] = "borderEndStartRadius";
    CssPropertyEnumCssPropertyType["borderEndEndRadius"] = "borderEndEndRadius";
    /** font properties */
    CssPropertyEnumCssPropertyType["font"] = "font";
    CssPropertyEnumCssPropertyType["fontFamily"] = "fontFamily";
    CssPropertyEnumCssPropertyType["fontSize"] = "fontSize";
    CssPropertyEnumCssPropertyType["fontStretch"] = "fontStretch";
    CssPropertyEnumCssPropertyType["fontStyle"] = "fontStyle";
    CssPropertyEnumCssPropertyType["fontVariant"] = "fontVariant";
    CssPropertyEnumCssPropertyType["fontWeight"] = "fontWeight";
    CssPropertyEnumCssPropertyType["lineHeight"] = "lineHeight";
    /** text properties */
    CssPropertyEnumCssPropertyType["color"] = "color";
    CssPropertyEnumCssPropertyType["letterSpacing"] = "letterSpacing";
    CssPropertyEnumCssPropertyType["writingMode"] = "writingMode";
    CssPropertyEnumCssPropertyType["textAlign"] = "textAlign";
    CssPropertyEnumCssPropertyType["textTransform"] = "textTransform";
    CssPropertyEnumCssPropertyType["textShadow"] = "textShadow";
    CssPropertyEnumCssPropertyType["textOverflow"] = "textOverflow";
    CssPropertyEnumCssPropertyType["textIndent"] = "textIndent";
    /** text-decoration properties */
    CssPropertyEnumCssPropertyType["textDecoration"] = "textDecoration";
    CssPropertyEnumCssPropertyType["textDecorationColor"] = "textDecorationColor";
    CssPropertyEnumCssPropertyType["textDecorationLine"] = "textDecorationLine";
    CssPropertyEnumCssPropertyType["textDecorationStyle"] = "textDecorationStyle";
    CssPropertyEnumCssPropertyType["textDecorationThickness"] = "textDecorationThickness";
    /** box related properties */
    CssPropertyEnumCssPropertyType["boxShadow"] = "boxShadow";
    CssPropertyEnumCssPropertyType["opacity"] = "opacity";
    CssPropertyEnumCssPropertyType["overflow"] = "overflow";
    /** layout properties */
    CssPropertyEnumCssPropertyType["display"] = "display";
    CssPropertyEnumCssPropertyType["alignSelf"] = "alignSelf";
    CssPropertyEnumCssPropertyType["justifyContent"] = "justifyContent";
    CssPropertyEnumCssPropertyType["alignItems"] = "alignItems";
    CssPropertyEnumCssPropertyType["flexDirection"] = "flexDirection";
    CssPropertyEnumCssPropertyType["height"] = "height";
    CssPropertyEnumCssPropertyType["width"] = "width";
    CssPropertyEnumCssPropertyType["gap"] = "gap";
    CssPropertyEnumCssPropertyType["columnGap"] = "columnGap";
    CssPropertyEnumCssPropertyType["rowGap"] = "rowGap";
    /** filters */
    CssPropertyEnumCssPropertyType["filter"] = "filter";
    CssPropertyEnumCssPropertyType["backdropFilter"] = "backdropFilter";
    /** media sizing & alignment */
    CssPropertyEnumCssPropertyType["objectFit"] = "objectFit";
    CssPropertyEnumCssPropertyType["objectPosition"] = "objectPosition";
    /** blending & compositing */
    CssPropertyEnumCssPropertyType["mixBlendMode"] = "mixBlendMode";
    CssPropertyEnumCssPropertyType["isolation"] = "isolation";
    /** stroke properties */
    CssPropertyEnumCssPropertyType["stroke"] = "stroke";
    CssPropertyEnumCssPropertyType["strokeWidth"] = "strokeWidth";
    CssPropertyEnumCssPropertyType["strokeOpacity"] = "strokeOpacity";
    /** fill properties */
    CssPropertyEnumCssPropertyType["fill"] = "fill";
    CssPropertyEnumCssPropertyType["fillOpacity"] = "fillOpacity";
})(CssPropertyEnumCssPropertyType || (CssPropertyEnumCssPropertyType = {}));
export var InteractionsTrigger;
(function (InteractionsTrigger) {
    InteractionsTrigger["UNKNOWN_TRIGGER"] = "UNKNOWN_TRIGGER";
    /** When a compoent is hovered */
    InteractionsTrigger["hover"] = "hover";
    /** When a component is clicked */
    InteractionsTrigger["click"] = "click";
    /** When the component enters the viewport */
    InteractionsTrigger["viewEnter"] = "viewEnter";
    /** Used for infinite-loop animations - mapped to `state` type of https://drafts.csswg.org/css-animations-2/#animation-trigger-type */
    InteractionsTrigger["pageVisible"] = "pageVisible";
    /** Mapped to native ViewTimeline */
    InteractionsTrigger["viewProgress"] = "viewProgress";
    /** Mapped to pointermove events on the element */
    InteractionsTrigger["pointerMove"] = "pointerMove";
    /** Mapped to animationend events */
    InteractionsTrigger["animationEnd"] = "animationEnd";
})(InteractionsTrigger || (InteractionsTrigger = {}));
export var EffectGroup;
(function (EffectGroup) {
    EffectGroup["UNKNOWN_EFFECT_GROUP"] = "UNKNOWN_EFFECT_GROUP";
    /** Effects that are applied to the background layer of the component */
    EffectGroup["background"] = "background";
})(EffectGroup || (EffectGroup = {}));
export var RestrictionLevel;
(function (RestrictionLevel) {
    RestrictionLevel["UNKNOWN_RESTRICTION_TYPE"] = "UNKNOWN_RESTRICTION_TYPE";
    /** Users can edit the product field after acknowledging a warning modal. */
    RestrictionLevel["WARNING"] = "WARNING";
    /** Users **cannot** edit the product field. */
    RestrictionLevel["LOCKED"] = "LOCKED";
})(RestrictionLevel || (RestrictionLevel = {}));
export var ElementDisplayOption;
(function (ElementDisplayOption) {
    ElementDisplayOption["UNKNOWN_OPTION"] = "UNKNOWN_OPTION";
    ElementDisplayOption["REMOVE"] = "REMOVE";
    ElementDisplayOption["CUSTOMIZED"] = "CUSTOMIZED";
})(ElementDisplayOption || (ElementDisplayOption = {}));
export var SidebarDataType;
(function (SidebarDataType) {
    SidebarDataType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    SidebarDataType["CATEGORY"] = "CATEGORY";
    SidebarDataType["PAGE"] = "PAGE";
    SidebarDataType["SEPARATOR"] = "SEPARATOR";
})(SidebarDataType || (SidebarDataType = {}));
/** Type of sidebar entity in a back office sidebar (cluster/category/page) */
export var SidebarEntityType;
(function (SidebarEntityType) {
    SidebarEntityType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    SidebarEntityType["CATEGORY"] = "CATEGORY";
    SidebarEntityType["PAGE"] = "PAGE";
    SidebarEntityType["APP"] = "APP";
})(SidebarEntityType || (SidebarEntityType = {}));
/**
 * Supported filter operators.
 * These are used by the API to define a filter and by the SPI to declare supported operations.
 * NOTICE: this list is not exhaustive and may change over time.
 */
export var OperatorEnumOperator;
(function (OperatorEnumOperator) {
    OperatorEnumOperator["UNKNOWN_OPERATOR"] = "UNKNOWN_OPERATOR";
    /** [Comparison] Matches values that are equal to a specified value. */
    OperatorEnumOperator["EQ"] = "EQ";
    /** [Comparison] Matches all values that are not equal to a specified value. */
    OperatorEnumOperator["NEQ"] = "NEQ";
    /** [Comparison] Matches values that are greater than a specified value. */
    OperatorEnumOperator["GT"] = "GT";
    /** [Comparison] Matches values that are greater than or equal to a specified value. */
    OperatorEnumOperator["GTE"] = "GTE";
    /** [Comparison] Matches values that are less than a specified value. */
    OperatorEnumOperator["LT"] = "LT";
    /** [Comparison] Matches values that are less than or equal to a specified value. */
    OperatorEnumOperator["LTE"] = "LTE";
    /** [Comparison] Matches values that fall within a specified range (inclusive). */
    OperatorEnumOperator["BETWEEN"] = "BETWEEN";
    /** [Comparison] Matches any of the values specified in an array. */
    OperatorEnumOperator["IN"] = "IN";
    /** [Comparison] Matches none of the values specified in an array. */
    OperatorEnumOperator["NIN"] = "NIN";
    /** [Existence] Matches values that are empty (e.g., empty string, null). */
    OperatorEnumOperator["EMPTY"] = "EMPTY";
    /** [Existence] Matches values that are not empty (e.g., non-empty string, not null). */
    OperatorEnumOperator["NOT_EMPTY"] = "NOT_EMPTY";
    /** [String] Matches values that start with a specified prefix. */
    OperatorEnumOperator["STARTS_WITH"] = "STARTS_WITH";
    /** [Array] Matches values that contain all specified items in an array. */
    OperatorEnumOperator["HAS_ALL"] = "HAS_ALL";
    /** [Array] Matches values that contain at least one of the specified items in an array. */
    OperatorEnumOperator["HAS_SOME"] = "HAS_SOME";
    /**
     * matches any value.
     * Example usage - "user bought ANY product"
     */
    OperatorEnumOperator["ANY"] = "ANY";
})(OperatorEnumOperator || (OperatorEnumOperator = {}));
/** Supported parameter data types */
export var ParameterType;
(function (ParameterType) {
    ParameterType["UNKNOWN_PARAMETER_TYPE"] = "UNKNOWN_PARAMETER_TYPE";
    ParameterType["STRING"] = "STRING";
    ParameterType["INT"] = "INT";
    ParameterType["DECIMAL"] = "DECIMAL";
    ParameterType["BOOL"] = "BOOL";
    /** ISO 4217 currency codes */
    ParameterType["CURRENCY"] = "CURRENCY";
    /** ISO 3166-2 codes for subdivisions */
    ParameterType["COUNTRY_SUBDIVISION"] = "COUNTRY_SUBDIVISION";
    /** ISO 639-1 language code */
    ParameterType["LANGUAGE"] = "LANGUAGE";
})(ParameterType || (ParameterType = {}));
/**
 * This new enum becomes the primary driver for the 'value_definition_details' oneof.
 * It explicitly lists each way a filter parameter's values can be defined.
 */
export var FilterValueDefinitionMode;
(function (FilterValueDefinitionMode) {
    FilterValueDefinitionMode["UNKNOWN_FILTER_VALUE_DEFINITION_MODE"] = "UNKNOWN_FILTER_VALUE_DEFINITION_MODE";
    /**
     * For "any value": Relies on 'FilterParameterDefinition.fundamental_data_type'.
     * No specific message will be set in the 'value_definition_details' oneof.
     */
    FilterValueDefinitionMode["ANY_VALUE_OF_SPECIFIED_TYPE"] = "ANY_VALUE_OF_SPECIFIED_TYPE";
    FilterValueDefinitionMode["ITEM_SELECTION"] = "ITEM_SELECTION";
    FilterValueDefinitionMode["STRING_LIST"] = "STRING_LIST";
    FilterValueDefinitionMode["INT_LIST"] = "INT_LIST";
    FilterValueDefinitionMode["DECIMAL_LIST"] = "DECIMAL_LIST";
    FilterValueDefinitionMode["BOOL_LIST"] = "BOOL_LIST";
    FilterValueDefinitionMode["CURRENCY_LIST"] = "CURRENCY_LIST";
    FilterValueDefinitionMode["COUNTRY_SUBDIVISION_LIST"] = "COUNTRY_SUBDIVISION_LIST";
    FilterValueDefinitionMode["LANGUAGE_TAG_LIST"] = "LANGUAGE_TAG_LIST";
})(FilterValueDefinitionMode || (FilterValueDefinitionMode = {}));
/**
 * Supported time-window types for a capability.
 * These are used by the API to define a filter and by the SPI to declare supported time constraints.
 */
export var TimeConstraintType;
(function (TimeConstraintType) {
    TimeConstraintType["UNKNOWN_TIME_CONSTRAINT_TYPE"] = "UNKNOWN_TIME_CONSTRAINT_TYPE";
    /** e.g., "last 30 days" */
    TimeConstraintType["LAST_DAYS"] = "LAST_DAYS";
    /** e.g., "last 24 hours" */
    TimeConstraintType["LAST_HOURS"] = "LAST_HOURS";
    /** e.g., "next 7 days" */
    TimeConstraintType["NEXT_DAYS"] = "NEXT_DAYS";
    /** e.g., "next 3 hours" */
    TimeConstraintType["NEXT_HOURS"] = "NEXT_HOURS";
    /** e.g., "between two specific dates" */
    TimeConstraintType["BETWEEN"] = "BETWEEN";
    /** Today */
    TimeConstraintType["TODAY"] = "TODAY";
    /** This month */
    TimeConstraintType["THIS_MONTH"] = "THIS_MONTH";
})(TimeConstraintType || (TimeConstraintType = {}));
/** Enum for the different types of value constraints */
export var ValueConstraintType;
(function (ValueConstraintType) {
    ValueConstraintType["UNKNOWN_VALUE_CONSTRAINT_TYPE"] = "UNKNOWN_VALUE_CONSTRAINT_TYPE";
    /** No constraints - user can enter any value */
    ValueConstraintType["NONE"] = "NONE";
    /** Provider supports only specific predefined values */
    ValueConstraintType["PREDEFINED_VALUES"] = "PREDEFINED_VALUES";
    /** Provider supports any value within a min-max range */
    ValueConstraintType["MIN_MAX_RANGE"] = "MIN_MAX_RANGE";
    /** Provider supports range constraints for date ranges */
    ValueConstraintType["RANGE"] = "RANGE";
})(ValueConstraintType || (ValueConstraintType = {}));
export var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType || (MediaType = {}));
export var PlanStatus;
(function (PlanStatus) {
    PlanStatus["UNKNOWN"] = "UNKNOWN";
    /** show this plan on app market */
    PlanStatus["VISIBLE"] = "VISIBLE";
    /** hide this plan */
    PlanStatus["HIDDEN"] = "HIDDEN";
})(PlanStatus || (PlanStatus = {}));
export var PlanDescription;
(function (PlanDescription) {
    PlanDescription["UNKNOWN_DESCRIPTION"] = "UNKNOWN_DESCRIPTION";
    /** indicate that the description will be list of benefits */
    PlanDescription["BENEFITS"] = "BENEFITS";
    /** indicate that the description will custom_text field */
    PlanDescription["CUSTOM_TEXT"] = "CUSTOM_TEXT";
})(PlanDescription || (PlanDescription = {}));
export var BusinessModel;
(function (BusinessModel) {
    BusinessModel["None"] = "None";
    BusinessModel["FREEMIUM"] = "FREEMIUM";
    BusinessModel["PREMIUM"] = "PREMIUM";
    BusinessModel["FREE"] = "FREE";
    BusinessModel["WIX_PREMIUM"] = "WIX_PREMIUM";
    BusinessModel["DYNAMIC"] = "DYNAMIC";
})(BusinessModel || (BusinessModel = {}));
export var OpenConsentIn;
(function (OpenConsentIn) {
    OpenConsentIn["NONE_VALUE"] = "NONE_VALUE";
    OpenConsentIn["NEW_WINDOW"] = "NEW_WINDOW";
    OpenConsentIn["NEW_TAB"] = "NEW_TAB";
})(OpenConsentIn || (OpenConsentIn = {}));
export var UninstallActions;
(function (UninstallActions) {
    UninstallActions["NONE_ACTION"] = "NONE_ACTION";
    UninstallActions["NO_ACTION"] = "NO_ACTION";
    UninstallActions["REMOVE_ALL_PRODUCT"] = "REMOVE_ALL_PRODUCT";
    UninstallActions["SHIPPING_RATES_REGION"] = "SHIPPING_RATES_REGION";
})(UninstallActions || (UninstallActions = {}));
export var RoleType;
(function (RoleType) {
    /** Not supported */
    RoleType["NO_ROLE"] = "NO_ROLE";
    /** View, edit */
    RoleType["OWNER"] = "OWNER";
    /** Not supported */
    RoleType["DEVELOPER"] = "DEVELOPER";
    /** View, edit */
    RoleType["ADMIN"] = "ADMIN";
    /** App market teams role. Do not use. */
    RoleType["GOD"] = "GOD";
})(RoleType || (RoleType = {}));
export var DependencyData;
(function (DependencyData) {
    /** quiet installation */
    DependencyData["PROVISION_ONLY_INSTALLATION"] = "PROVISION_ONLY_INSTALLATION";
    DependencyData["NOTIFY_USER_ON_DEPENDENCY"] = "NOTIFY_USER_ON_DEPENDENCY";
    DependencyData["IS_BUNDLE"] = "IS_BUNDLE";
})(DependencyData || (DependencyData = {}));
export var Status;
(function (Status) {
    Status["EMPTY"] = "EMPTY";
    /** the app was installed on this meta site id */
    Status["INSTALLED"] = "INSTALLED";
    /** meaning the app needs the user to finish the installation (for example add the app in the editor) */
    Status["PENDING"] = "PENDING";
})(Status || (Status = {}));
export var RenewalType;
(function (RenewalType) {
    RenewalType["UNKNOWN"] = "UNKNOWN";
    /** ubscription renewed when current period ends with automatic payment method, for example credit card */
    RenewalType["AUTO_RENEW_ON"] = "AUTO_RENEW_ON";
    /** ubscription is turned off at current period end date */
    RenewalType["AUTO_RENEW_OFF"] = "AUTO_RENEW_OFF";
    /** ubscription is renewed when current period ends only if paid for manually */
    RenewalType["MANUAL"] = "MANUAL";
})(RenewalType || (RenewalType = {}));
//# sourceMappingURL=types.impl.js.map